<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text"
                    >Gps Tracking</v-toolbar-title
                >
                <v-spacer></v-spacer>
            </v-toolbar>
            <div>
                <div style="height: 150px">
                    <v-container fluid>
                        <div class="inl1 mt-3">
                            <div class="lin1">
                                <v-combobox
                                    id="combox"
                                    class="mx-2"
                                    dense
                                    prepend-icon="mdi-calendar-refresh"
                                    @click:prepend="getShiftDetails()"
                                    v-model="comboShiftDates"
                                    :items="shiftDates"
                                    :item-text="'ShiftDate'"
                                    :item-value="'ShiftId'"
                                    label="Shift Dates"
                                    :index="indexShift"
                                    hide-details
                                    aria-activedescendant="list-item-210-10"
                                    @change="getShiftDetails()"
                                ></v-combobox>
                            </div>

                            <div class="lin15 ">
                                <v-combobox
                                    id="combox"
                                    class="mx-2"
                                    dense
                                    v-model="comboDrivers"
                                    :items="shiftDetailsDrivers"
                                    label="Trailer"
                                    :item-text="'Trailer'"
                                    :item-value="'ShiftDetail'"
                                    auto-select-first
                                    hide-details
                                    return-object
                                    @change="showShiftDetails()"
                                ></v-combobox>
                            </div>

                            <div class="lin15">
                                <v-combobox
                                    id="combox"
                                    class="mx-2"
                                    dense
                                    v-model="comboDrivers"
                                    :items="shiftDetailsDrivers"
                                    label="Truck"
                                    :item-text="'Truck'"
                                    :item-value="'ShiftDetail'"
                                    auto-select-first
                                    hide-details
                                    return-object
                                    @change="showShiftDetails()"
                                ></v-combobox>
                            </div>

                            <div class="lin2 mt-2">
                                <v-combobox
                                    id="combox"
                                    class="mx-2"
                                    dense
                                    v-model="comboDrivers"
                                    :items="shiftDetailsDrivers"
                                    append-outer-icon="mdi-account-filter-outline"
                                    prepend-icon="mdi-refresh"
                                    @click:prepend="showShiftDetails"
                                    @click:append-outer="filterShDrivers"
                                    label="Driver"
                                    :item-text="'Driver'"
                                    :item-value="'ShiftDetail'"
                                    auto-select-first
                                    hide-details
                                    return-object
                                    @change="showShiftDetails()"
                                ></v-combobox>
                            </div>
                        </div>
                        <div class="inlTbl">
                            <div class="linTab1 tbla">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Shift Detail</th>
                                            <th>Driver</th>
                                            <th>Truck</th>
                                            <th>Yard</th>
                                            <th>Trailer</th>
                                            <th>Shift Start Time</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {{
                                                    this.shiftDetails
                                                        .ShiftDetail
                                                }}
                                            </td>
                                            <td>
                                                {{ this.shiftDetails.Driver }}
                                            </td>
                                            <td>
                                                {{ this.shiftDetails.Truck }}
                                            </td>

                                            <td>
                                                {{ this.shiftDetails.Yard }}
                                            </td>

                                            <td>
                                                {{ this.shiftDetails.Trailer }}
                                            </td>
                                            <td>
                                                {{
                                                    shiftDetails.ShiftStartTime
                                                }}
                                            </td>
                                            <td>
                                                <v-btn
                                                    v-if="
                                                        $store.state.roles ==
                                                            'Administrator' ||
                                                            $store.state
                                                                .roles ==
                                                                'TrackingSupervisor'
                                                    "
                                                    icon
                                                    small
                                                    color="primary"
                                                    class="mr-1"
                                                    :loading="saving"
                                                    :disabled="saving"
                                                    @click="
                                                        getTotalCount(
                                                            'Totals Drops by User'
                                                        )
                                                    "
                                                >
                                                    <abbr title="Total Dropps">
                                                        <v-icon
                                                            >mdi-counter</v-icon
                                                        >
                                                    </abbr>
                                                </v-btn>
                                                <v-btn
                                                    v-if="
                                                        $store.state.roles ==
                                                            'Administrator' ||
                                                            $store.state
                                                                .roles ==
                                                                'TrackingSupervisor'
                                                    "
                                                    icon
                                                    small
                                                    color="primary"
                                                    class="mr-1"
                                                    :loading="saving"
                                                    :disabled="saving"
                                                    @click="
                                                        getTotalCount(
                                                            'Totals Comments by User'
                                                        )
                                                    "
                                                >
                                                    <abbr
                                                        title="Total Comments"
                                                    >
                                                        <v-icon
                                                            >mdi-numeric-9-plus-box-multiple-outline</v-icon
                                                        >
                                                    </abbr>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    small
                                                    color="primary"
                                                    class="mx-1"
                                                    :loading="saving"
                                                    :disabled="saving"
                                                    @click="getCKDrop()"
                                                >
                                                    <v-icon
                                                        >mdi-check-decagram</v-icon
                                                    >
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    small
                                                    color="primary"
                                                    :loading="saving"
                                                    class="mx-1"
                                                    :disabled="saving"
                                                    @click="getTrackingDiff()"
                                                >
                                                    <v-icon
                                                        >mdi-timer-sand</v-icon
                                                    >
                                                </v-btn>
                                                <v-btn
                                                    class="mx-1"
                                                    color="primary"
                                                    icon
                                                    @click="
                                                        $store.state.tracking.pendings = true
                                                    "
                                                    ><v-icon
                                                        >mdi-receipt-text-clock-outline</v-icon
                                                    ></v-btn
                                                >
                                                <v-btn
                                                    color="primary"
                                                    icon
                                                    @click="
                                                        downloadDiffHoursReport
                                                    "
                                                    ><v-icon
                                                        >mdi-timer-lock</v-icon
                                                    ></v-btn
                                                >
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="linTab1 tbla">
                                <table>
                                    <tbody>
                                        <tr>
                                            <th>Log Start Time</th>
                                            <th>GPS Start Time</th>
                                            <th>Pretrip</th>
                                            <th>DiffStart</th>
                                            <th>GPS End Time</th>
                                            <th>Log End Time</th>
                                            <th>Posttrip</th>
                                            <th>DiffEnd</th>
                                        </tr>
                                        <tr>
                                            <td
                                                id="divs"
                                                v-show="ShowLogStart"
                                                width="20%"
                                                :style="
                                                    LogStartOrigin == 2
                                                        ? 'border-bottom: 1px solid #777;background-color: #80D8A6;'
                                                        : LogStartOrigin == 3
                                                        ? 'border-bottom: 1px solid #777;background-color: #80D8D5;'
                                                        : LogStartOrigin == 4
                                                        ? 'border-bottom: 1px solid #777;background-color: #eff93f;'
                                                        : 'border-bottom: 1px solid #777;'
                                                "
                                            >
                                                <p
                                                    v-if="
                                                        shiftDetails.LogStart !=
                                                            '' &&
                                                            shiftDetails.LogStart !=
                                                                null &&
                                                            shiftDetails.LogStart !=
                                                                undefined
                                                    "
                                                    @click="
                                                        ShowLogStart = false
                                                    "
                                                    style="margin: 0;font-size: 13px;"
                                                >
                                                    {{
                                                        shiftDetails.LogStartDate
                                                    }}
                                                    <strong
                                                        class="timeShiftValue"
                                                    >
                                                        {{
                                                            shiftDetails.LogStartTime
                                                        }}
                                                    </strong>
                                                </p>
                                                <p
                                                    v-else
                                                    @click="
                                                        ShowLogStart = false
                                                    "
                                                    class="replicateShiftPlaceholder"
                                                >
                                                    YYYY-MM-DD HH:MM
                                                </p>
                                            </td>
                                            <td
                                                id="divs"
                                                width="20%"
                                                v-show="!ShowLogStart"
                                            >
                                                <v-text-field
                                                    autofocus
                                                    style="
                                                            font-size: 13px;
                                                            padding: 0px;
                                                            margin: 0px;
                                                        "
                                                    placeholder="YYYY-MM-DD HH:MM"
                                                    v-mask="'####-##-## ##:##'"
                                                    type="tel"
                                                    id="LogStart"
                                                    :rules="dateRules"
                                                    :value="
                                                        shiftDetails.LogStart
                                                    "
                                                    @focus="notSave('LogStart')"
                                                    @change="
                                                        saveChangeShift(
                                                            'LogStart'
                                                        )
                                                    "
                                                    @blur="ShowLogStart = true"
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td
                                                id="divs"
                                                v-show="ShowGPSShiftStart"
                                                width="20%"
                                                :style="
                                                    GPSShiftStartOrigin == 2
                                                        ? 'border-bottom: 1px solid #777;background-color: #80D8A6;'
                                                        : GPSShiftStartOrigin ==
                                                          3
                                                        ? 'border-bottom: 1px solid #777;background-color: #80D8D5;'
                                                        : GPSShiftStartOrigin ==
                                                          4
                                                        ? 'border-bottom: 1px solid #777;background-color: #eff93f;'
                                                        : 'border-bottom: 1px solid #777;'
                                                "
                                            >
                                                <p
                                                    v-if="
                                                        shiftDetails.GPSShiftStart !=
                                                            '' &&
                                                            shiftDetails.GPSShiftStart !=
                                                                null &&
                                                            shiftDetails.GPSShiftStart !=
                                                                undefined
                                                    "
                                                    @click="
                                                        ShowGPSShiftStart = false
                                                    "
                                                    style="margin: 0;font-size: 13px;"
                                                >
                                                    {{
                                                        shiftDetails.GPSShiftStartDate
                                                    }}
                                                    <strong
                                                        class="timeShiftValue"
                                                    >
                                                        {{
                                                            shiftDetails.GPSShiftStartTime
                                                        }}
                                                    </strong>
                                                </p>
                                                <p
                                                    v-else
                                                    @click="
                                                        ShowGPSShiftStart = false
                                                    "
                                                    class="replicateShiftPlaceholder"
                                                >
                                                    YYYY-MM-DD HH:MM
                                                </p>
                                            </td>
                                            <td
                                                id="divs"
                                                v-show="!ShowGPSShiftStart"
                                                width="20%"
                                            >
                                                <v-text-field
                                                    autofocus
                                                    style="
                                                            font-size: 13px;
                                                            padding: 0px;
                                                            margin: 0px;
                                                        "
                                                    placeholder="YYYY-MM-DD HH:MM"
                                                    v-mask="'####-##-## ##:##'"
                                                    type="tel"
                                                    id="GPSShiftStart"
                                                    :rules="dateRules"
                                                    :value="
                                                        shiftDetails.GPSShiftStart
                                                    "
                                                    @focus="
                                                        notSave('GPSShiftStart')
                                                    "
                                                    @change="
                                                        saveChangeShift(
                                                            'GPSShiftStart'
                                                        )
                                                    "
                                                    @blur="
                                                        ShowGPSShiftStart = true
                                                    "
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td width="5%">
                                                <v-checkbox
                                                    style="margin-bottom: 5px;padding: 0 0 0 8px;"
                                                    hide-details
                                                    dense
                                                    v-model="
                                                        shiftDetails.PreTrip
                                                    "
                                                    @change="
                                                        saveChangeShift(
                                                            'PreTrip'
                                                        )
                                                    "
                                                ></v-checkbox>
                                            </td>
                                            <td
                                                width="5%"
                                                :style="
                                                    shiftDetails.DiffStart >
                                                        0 &&
                                                    shiftDetails.DiffStart < 15
                                                        ? 'background:#ff6961;'
                                                        : shiftDetails.DiffStart >
                                                          35
                                                        ? 'background:#fdfd96;'
                                                        : ''
                                                "
                                            >
                                                {{ shiftDetails.DiffStart }}
                                            </td>
                                            <td
                                                id="divs"
                                                v-show="ShowGPSShiftEnd"
                                                width="20%"
                                                :style="
                                                    GPSShiftEndOrigin == 2
                                                        ? 'border-bottom: 1px solid #777;background-color: #80D8A6;'
                                                        : GPSShiftEndOrigin == 3
                                                        ? 'border-bottom: 1px solid #777;background-color: #80D8D5;'
                                                        : GPSShiftEndOrigin == 4
                                                        ? 'border-bottom: 1px solid #777;background-color: #eff93f;'
                                                        : 'border-bottom: 1px solid #777;'
                                                "
                                            >
                                                <p
                                                    v-if="
                                                        shiftDetails.GPSShiftEnd !=
                                                            '' &&
                                                            shiftDetails.GPSShiftEnd !=
                                                                null &&
                                                            shiftDetails.GPSShiftEnd !=
                                                                undefined
                                                    "
                                                    @click="
                                                        ShowGPSShiftEnd = false
                                                    "
                                                    style="margin: 0;font-size: 13px;"
                                                >
                                                    {{
                                                        shiftDetails.GPSShiftEndDate
                                                    }}
                                                    <strong
                                                        class="timeShiftValue"
                                                    >
                                                        {{
                                                            shiftDetails.GPSShiftEndTime
                                                        }}
                                                    </strong>
                                                </p>
                                                <p
                                                    v-else
                                                    @click="
                                                        ShowGPSShiftEnd = false
                                                    "
                                                    class="replicateShiftPlaceholder"
                                                >
                                                    YYYY-MM-DD HH:MM
                                                </p>
                                            </td>
                                            <td
                                                id="divs"
                                                width="20%"
                                                v-show="!ShowGPSShiftEnd"
                                            >
                                                <v-text-field
                                                    autofocus
                                                    style="
                                                            font-size: 13px;
                                                            padding: 0px;
                                                            margin: 0px;
                                                        "
                                                    placeholder="YYYY-MM-DD HH:MM"
                                                    v-mask="'####-##-## ##:##'"
                                                    type="tel"
                                                    id="GPSShiftEnd"
                                                    :rules="dateRules"
                                                    :value="
                                                        shiftDetails.GPSShiftEnd
                                                    "
                                                    @focus="
                                                        notSave('GPSShiftEnd')
                                                    "
                                                    @change="
                                                        saveChangeShift(
                                                            'GPSShiftEnd'
                                                        )
                                                    "
                                                    @blur="
                                                        ShowGPSShiftEnd = true
                                                    "
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td
                                                id="divs"
                                                v-show="ShowLogEnd"
                                                width="20%"
                                                :style="
                                                    LogEndOrigin == 2
                                                        ? 'border-bottom: 1px solid #777;background-color: #80D8A6;'
                                                        : LogEndOrigin == 3
                                                        ? 'border-bottom: 1px solid #777;background-color: #80D8D5;'
                                                        : LogEndOrigin == 4
                                                        ? 'border-bottom: 1px solid #777;background-color: #eff93f;'
                                                        : 'border-bottom: 1px solid #777;'
                                                "
                                            >
                                                <p
                                                    v-if="
                                                        shiftDetails.LogEnd !=
                                                            '' &&
                                                            shiftDetails.LogEnd !=
                                                                null &&
                                                            shiftDetails.LogEnd !=
                                                                undefined
                                                    "
                                                    @click="ShowLogEnd = false"
                                                    style="margin: 0;font-size: 13px;"
                                                >
                                                    {{
                                                        shiftDetails.LogEndDate
                                                    }}
                                                    <strong
                                                        class="timeShiftValue"
                                                    >
                                                        {{
                                                            shiftDetails.LogEndTime
                                                        }}
                                                    </strong>
                                                </p>
                                                <p
                                                    v-else
                                                    @click="ShowLogEnd = false"
                                                    class="replicateShiftPlaceholder"
                                                >
                                                    YYYY-MM-DD HH:MM
                                                </p>
                                            </td>
                                            <td
                                                id="divs"
                                                width="20%"
                                                v-show="!ShowLogEnd"
                                            >
                                                <v-text-field
                                                    autofocus
                                                    style="
                                                            font-size: 13px;
                                                            padding: 0px;
                                                            margin: 0px;
                                                        "
                                                    placeholder="YYYY-MM-DD HH:MM"
                                                    v-mask="'####-##-## ##:##'"
                                                    type="tel"
                                                    id="LogEnd"
                                                    :rules="dateRules"
                                                    @focus="notSave('LogEnd')"
                                                    @change="
                                                        saveChangeShift(
                                                            'LogEnd'
                                                        )
                                                    "
                                                    :value="shiftDetails.LogEnd"
                                                    @blur="ShowLogEnd = true"
                                                    hide-details
                                                ></v-text-field>
                                            </td>
                                            <td width="5%">
                                                <v-checkbox
                                                    style="margin-bottom: 5px;padding: 0 0 0 8px;"
                                                    hide-details
                                                    dense
                                                    v-model="
                                                        shiftDetails.PostTrip
                                                    "
                                                    @change="
                                                        saveChangeShift(
                                                            'PostTrip'
                                                        )
                                                    "
                                                ></v-checkbox>
                                            </td>
                                            <td
                                                width="5%"
                                                :style="
                                                    shiftDetails.DiffEnd > 0 &&
                                                    shiftDetails.DiffEnd < 15
                                                        ? 'background:#ff6961;'
                                                        : shiftDetails.DiffEnd >
                                                          35
                                                        ? 'background:#fdfd96;'
                                                        : ''
                                                "
                                            >
                                                {{ shiftDetails.DiffEnd }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="inl3">
                            <div class="linCtm">
                                <v-textarea
                                    label="Comments"
                                    dense
                                    height="100"
                                    hide-details
                                    id="GPSComments"
                                    @focus="notSave('GPSComments')"
                                    v-model="shiftDetails.GPSComments"
                                    @change="saveChangeShift('GPSComments')"
                                    outlined
                                ></v-textarea>
                            </div>
                        </div>
                    </v-container>
                </div>
            </div>
        </v-card>
        <v-container grid-list-xs fluid>
            <v-divider></v-divider>
            <!--     ORDERS    -->
            <div v-if="loadingOrders">
                <v-progress-linear
                    :size="50"
                    color="primary"
                    indeterminate
                ></v-progress-linear>
            </div>
            <div class="dspSum">
                <div class="header">
                    <div class="sumTabs tbla">
                        <table>
                            <thead>
                                <th style="width: 8%">OrderID</th>
                                <th style="width: 8%">Order Status</th>
                                <th style="width: 2%">L1</th>
                                <th style="width: 2%">L2</th>
                                <th style="width: 15%">Terminal</th>
                                <th style="width: 15%">Station</th>
                                <th style="width: 8%">City</th>
                                <th style="width: 10%">ETA</th>
                                <th style="width: 10%">Retain</th>
                                <th style="width: 5%">Goal Post</th>
                                <th style="width: 10%">Run Out</th>
                            </thead>
                        </table>
                    </div>
                    <div class="sumComt">
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
                <div class="sumBody">
                    <div v-if="orders.length" style="height: 120px">
                        <v-list>
                            <!-- <draggable
                                v-model="orders"
                                group="OrderID"
                                style="max-height: 450px"
                                :disabled="disabled"
                                @update="dragMoveOrder"
                            > -->
                            <div v-for="(order, i) in orders" :key="i">
                                <v-list-item style="padding: 0;">
                                    <div :class="order.rowsCtm">
                                        <div class="tabs">
                                            <div class="lin2">
                                                <table>
                                                    <tbody>
                                                        <tr
                                                            :class="
                                                                order.tbFont
                                                            "
                                                        >
                                                            <td
                                                                style="
                                                                        width: 8%;
                                                                        text-align: center;
                                                                    "
                                                            >
                                                                {{
                                                                    order.OrderID
                                                                }}
                                                            </td>
                                                            <td
                                                                style="width: 8%;background-color:#edd480;"
                                                                v-if="
                                                                    order.OrderStatus ==
                                                                        'PRELOAD'
                                                                "
                                                            >
                                                                {{
                                                                    order.OrderStatus
                                                                }}
                                                            </td>
                                                            <td
                                                                style="width: 8%;text-align:center;background-color:#cef5a9;"
                                                                v-else-if="
                                                                    order.OrderStatus ==
                                                                        'PRLDISPAT'
                                                                "
                                                            >
                                                                {{
                                                                    order.OrderStatus
                                                                }}
                                                            </td>
                                                            <td
                                                                style="width: 8%;text-align:center;"
                                                                v-else
                                                            >
                                                                {{
                                                                    order.OrderStatus
                                                                }}
                                                            </td>
                                                            <td
                                                                style="
                                                                        width: 2%;
                                                                        text-align: left;
                                                                    "
                                                            >
                                                                <!-- <v-text-field
                                                            dense
                                                            hide-details
                                                            v-model="order.LoadNum"
                                                            @change="onLoadOrderChange(order)"
                                                        ></v-text-field> -->
                                                                {{
                                                                    order.LoadNum
                                                                }}
                                                            </td>
                                                            <td
                                                                style="
                                                                        width: 2%;
                                                                        text-align: left;
                                                                    "
                                                            >
                                                                <!-- <v-text-field
                                                            dense
                                                            hide-details
                                                            v-model="order.LoadNumOrd"
                                                            @change="onLoadOrderChange(order)"
                                                        ></v-text-field> -->
                                                                {{
                                                                    order.LoadNumOrd
                                                                }}
                                                            </td>
                                                            <td
                                                                style="
                                                                        width: 15%;
                                                                        text-align: center;
                                                                    "
                                                                @click="
                                                                    copyPaper(
                                                                        order.Terminal,
                                                                        'Terminal',
                                                                        i
                                                                    )
                                                                "
                                                            >
                                                                {{
                                                                    order.Terminal
                                                                }}
                                                                <v-tooltip
                                                                    bottom
                                                                    v-model="
                                                                        order.copyT
                                                                    "
                                                                >
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                            attrs
                                                                        }"
                                                                    >
                                                                        <div
                                                                            v-bind="
                                                                                attrs
                                                                            "
                                                                            v-on="
                                                                                on
                                                                            "
                                                                        ></div>
                                                                    </template>
                                                                    <span
                                                                        >Terminal
                                                                        copied
                                                                        to
                                                                        clipboard</span
                                                                    >
                                                                </v-tooltip>
                                                            </td>

                                                            <td
                                                                style="
                                                                        width: 15%;
                                                                        text-align: center;
                                                                    "
                                                                @click="
                                                                    copyPaper(
                                                                        order.Station,
                                                                        'Station',
                                                                        i
                                                                    )
                                                                "
                                                            >
                                                                {{
                                                                    order.Station
                                                                }}
                                                                <v-tooltip
                                                                    bottom
                                                                    v-model="
                                                                        order.copyS
                                                                    "
                                                                >
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                            attrs
                                                                        }"
                                                                    >
                                                                        <div
                                                                            v-bind="
                                                                                attrs
                                                                            "
                                                                            v-on="
                                                                                on
                                                                            "
                                                                        ></div>
                                                                    </template>
                                                                    <span
                                                                        >Station
                                                                        copied
                                                                        to
                                                                        clipboard</span
                                                                    >
                                                                </v-tooltip>
                                                            </td>
                                                            <td
                                                                style="
                                                                        width: 8%;
                                                                        text-align: center;
                                                                    "
                                                            >
                                                                {{
                                                                    order.StationCity
                                                                }}
                                                            </td>

                                                            <td
                                                                style="
                                                                        width: 10%;
                                                                        text-align: center;
                                                                    "
                                                            >
                                                                {{
                                                                    order.ETATimeDate
                                                                }}
                                                                <strong
                                                                    class="timeGeneralValue"
                                                                    >{{
                                                                        order.ETATimeTime
                                                                    }}</strong
                                                                >
                                                            </td>
                                                            <td
                                                                style="
                                                                        width: 10%;
                                                                        text-align: center;
                                                                    "
                                                            >
                                                                {{
                                                                    order.RTTimeDate
                                                                }}
                                                                <strong
                                                                    class="timeGeneralValue"
                                                                    >{{
                                                                        order.RTTimeTime
                                                                    }}</strong
                                                                >
                                                            </td>
                                                            <td
                                                                style="
                                                                        width: 5%;
                                                                        text-align: center;
                                                                    "
                                                            >
                                                                {{
                                                                    order.GoalPostDate
                                                                }}

                                                                <strong
                                                                    :style="
                                                                        order.ETATime >
                                                                        order.GoalPostTime
                                                                            ? 'background: red;'
                                                                            : 'background: yellow;'
                                                                    "
                                                                    >{{
                                                                        order.GoalPostTimeTime
                                                                    }}</strong
                                                                >
                                                            </td>
                                                            <td
                                                                style="
                                                                        width: 10%;
                                                                        text-align: center;
                                                                    "
                                                            >
                                                                {{
                                                                    order.ROTimeDate
                                                                }}
                                                                <strong
                                                                    class="timeGeneralValue"
                                                                    >{{
                                                                        order.ROTimeTime
                                                                    }}</strong
                                                                >
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="lin2">
                                                <div>
                                                    <table>
                                                        <thead
                                                            :class="
                                                                order.tbFont
                                                            "
                                                        >
                                                            <tr>
                                                                <td
                                                                    width="10%"
                                                                    style="padding: 4px 0 0;"
                                                                >
                                                                    Terminal
                                                                    Start
                                                                </td>
                                                                <td
                                                                    v-show="
                                                                        order.showTStart
                                                                    "
                                                                    width="20%"
                                                                >
                                                                    <p
                                                                        v-if="
                                                                            order.TStartDate !=
                                                                                '' &&
                                                                                order.TStartDate !=
                                                                                    null &&
                                                                                order.TStartDate !=
                                                                                    undefined
                                                                        "
                                                                        @click="
                                                                            order.showTStart = false
                                                                        "
                                                                        :style="
                                                                            order.TStartOrigin ==
                                                                            2
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                                : order.TStartOrigin ==
                                                                                  3
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                                : order.TStartOrigin ==
                                                                                  4
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                                : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                                        "
                                                                    >
                                                                        {{
                                                                            order.TStartDate
                                                                        }}
                                                                        <strong
                                                                            class="timeLoadValue"
                                                                        >
                                                                            {{
                                                                                order.TStartTime
                                                                            }}
                                                                        </strong>
                                                                    </p>
                                                                    <p
                                                                        v-else
                                                                        @click="
                                                                            order.showTStart = false
                                                                        "
                                                                        class="replicatePlaceholder"
                                                                    >
                                                                        YYYY-MM-DD
                                                                        HH:MM
                                                                    </p>
                                                                </td>
                                                                <td
                                                                    v-show="
                                                                        !order.showTStart
                                                                    "
                                                                    width="20%"
                                                                >
                                                                    <v-text-field
                                                                        autofocus
                                                                        style="
                                                                                font-size: 13px;
                                                                                padding: 0;
                                                                                margin: 0;
                                                                                width: 140px;
                                                                            "
                                                                        placeholder="YYYY-MM-DD HH:MM"
                                                                        v-mask="
                                                                            '####-##-## ##:##'
                                                                        "
                                                                        @focus="
                                                                            notSaveLoad(
                                                                                'TStart' +
                                                                                    i
                                                                            )
                                                                        "
                                                                        dense
                                                                        type="tel"
                                                                        :rules="
                                                                            dateRules
                                                                        "
                                                                        :value="
                                                                            order.TStart
                                                                        "
                                                                        @change="
                                                                            saveOrderDates(
                                                                                'TStart',
                                                                                i,
                                                                                order
                                                                            )
                                                                        "
                                                                        @blur="
                                                                            calculateDiffTerminal(
                                                                                i,
                                                                                'TStart' +
                                                                                    i,

                                                                                'TEnd' +
                                                                                    i
                                                                            )
                                                                        "
                                                                        :id="
                                                                            'TStart' +
                                                                                i
                                                                        "
                                                                        hide-details
                                                                    ></v-text-field>
                                                                </td>
                                                                <td
                                                                    width="10%"
                                                                    v-if="
                                                                        order.timeDiffT >
                                                                            1.25
                                                                    "
                                                                    style="color: red;"
                                                                >
                                                                    Diff
                                                                    (hrs):{{
                                                                        order.timeDiffT
                                                                    }}
                                                                </td>
                                                                <td
                                                                    width="10%"
                                                                    v-else
                                                                >
                                                                    Diff
                                                                    (hrs):{{
                                                                        order.timeDiffT
                                                                    }}
                                                                </td>
                                                                <td
                                                                    width="10%"
                                                                    style="padding: 4px 0 0;"
                                                                >
                                                                    Station
                                                                    Start
                                                                </td>
                                                                <td
                                                                    v-show="
                                                                        order.showStStart
                                                                    "
                                                                    width="20%"
                                                                >
                                                                    <p
                                                                        @click="
                                                                            order.showStStart = false
                                                                        "
                                                                        :style="
                                                                            order.StStartOrigin ==
                                                                            2
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                                : order.StStartOrigin ==
                                                                                  3
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                                : order.StStartOrigin ==
                                                                                  4
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                                : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                                        "
                                                                        v-if="
                                                                            order.StStartDate !=
                                                                                '' &&
                                                                                order.StStartDate !=
                                                                                    null &&
                                                                                order.StStartDate !=
                                                                                    undefined
                                                                        "
                                                                    >
                                                                        {{
                                                                            order.StStartDate
                                                                        }}
                                                                        <strong
                                                                            class="timeLoadValue"
                                                                        >
                                                                            {{
                                                                                order.StStartTime
                                                                            }}
                                                                        </strong>
                                                                    </p>
                                                                    <p
                                                                        v-else
                                                                        @click="
                                                                            order.showStStart = false
                                                                        "
                                                                        class="replicatePlaceholder"
                                                                    >
                                                                        YYYY-MM-DD
                                                                        HH:MM
                                                                    </p>
                                                                </td>
                                                                <td
                                                                    v-show="
                                                                        !order.showStStart
                                                                    "
                                                                    width="20%"
                                                                >
                                                                    <v-text-field
                                                                        autofocus
                                                                        style="
                                                                                font-size: 13px;
                                                                                padding: 0;
                                                                                margin: 0;
                                                                                width: 140px;
                                                                            "
                                                                        placeholder="YYYY-MM-DD HH:MM"
                                                                        v-mask="
                                                                            '####-##-## ##:##'
                                                                        "
                                                                        dense
                                                                        type="tel"
                                                                        :rules="
                                                                            dateRules
                                                                        "
                                                                        @focus="
                                                                            notSaveLoad(
                                                                                'StStart' +
                                                                                    i
                                                                            )
                                                                        "
                                                                        @change="
                                                                            saveOrderDates(
                                                                                'StStart',
                                                                                i,
                                                                                order
                                                                            )
                                                                        "
                                                                        @blur="
                                                                            calculateDiffStation(
                                                                                i,
                                                                                'StStart' +
                                                                                    i,
                                                                                'StEnd' +
                                                                                    i
                                                                            )
                                                                        "
                                                                        :value="
                                                                            order.StStart
                                                                        "
                                                                        :id="
                                                                            'StStart' +
                                                                                i
                                                                        "
                                                                        hide-details
                                                                    ></v-text-field>
                                                                </td>

                                                                <td
                                                                    width="10%"
                                                                    v-if="
                                                                        order.timeDiffSt >
                                                                            1.25
                                                                    "
                                                                    style="color: red;"
                                                                >
                                                                    Diff (hrs):
                                                                    {{
                                                                        order.timeDiffSt
                                                                    }}
                                                                </td>
                                                                <td
                                                                    width="10%"
                                                                    v-else
                                                                >
                                                                    Diff (hrs):
                                                                    {{
                                                                        order.timeDiffSt
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <!-- <v-btn
                                                                icon
                                                                color="primary"
                                                                style="
                                                                            font-size: 10px;
                                                                            padding: 0px;
                                                                        "
                                                                @click="
                                                                    saveOrder(
                                                                        order,
                                                                        i
                                                                    )
                                                                "
                                                            >
                                                                <v-icon>
                                                                    mdi-content-save</v-icon
                                                                >
                                                            </v-btn> -->
                                                                </td>
                                                                <td width="10%">
                                                                    <v-btn
                                                                        icon
                                                                        :color="
                                                                            order.btnColor
                                                                        "
                                                                        style="
                                                                                font-size: 10px;
                                                                                padding: 0px;
                                                                            "
                                                                        @click="
                                                                            openData(
                                                                                order,
                                                                                i
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-icon>
                                                                            mdi-book-open</v-icon
                                                                        >
                                                                    </v-btn>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td
                                                                    style="padding: 6px 0 0;"
                                                                >
                                                                    Terminal End
                                                                </td>
                                                                <td
                                                                    v-show="
                                                                        order.showTEnd
                                                                    "
                                                                >
                                                                    <p
                                                                        @click="
                                                                            order.showTEnd = false
                                                                        "
                                                                        :style="
                                                                            order.TEndOrigin ==
                                                                            2
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                                : order.TEndOrigin ==
                                                                                  3
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                                : order.TEndOrigin ==
                                                                                  4
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                                : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                                        "
                                                                        v-if="
                                                                            order.TEndDate !=
                                                                                '' &&
                                                                                order.TEndDate !=
                                                                                    null &&
                                                                                order.TEndDate !=
                                                                                    undefined
                                                                        "
                                                                    >
                                                                        {{
                                                                            order.TEndDate
                                                                        }}
                                                                        <strong
                                                                            class="timeLoadValue"
                                                                        >
                                                                            {{
                                                                                order.TEndTime
                                                                            }}
                                                                        </strong>
                                                                    </p>
                                                                    <p
                                                                        v-else
                                                                        @click="
                                                                            order.showTEnd = false
                                                                        "
                                                                        class="replicatePlaceholder"
                                                                    >
                                                                        YYYY-MM-DD
                                                                        HH:MM
                                                                    </p>
                                                                </td>
                                                                <td
                                                                    v-show="
                                                                        !order.showTEnd
                                                                    "
                                                                >
                                                                    <v-text-field
                                                                        autofocus
                                                                        style="
                                                                                font-size: 13px;
                                                                                padding: 0;
                                                                                margin: 0;
                                                                                width: 140px;
                                                                            "
                                                                        placeholder="YYYY-MM-DD HH:MM"
                                                                        v-mask="
                                                                            '####-##-## ##:##'
                                                                        "
                                                                        dense
                                                                        type="tel"
                                                                        :rules="
                                                                            dateRules
                                                                        "
                                                                        :value="
                                                                            order.TEnd
                                                                        "
                                                                        @focus="
                                                                            notSaveLoad(
                                                                                'TEnd' +
                                                                                    i
                                                                            )
                                                                        "
                                                                        @change="
                                                                            saveOrderDates(
                                                                                'TEnd',
                                                                                i,
                                                                                order
                                                                            )
                                                                        "
                                                                        @blur="
                                                                            calculateDiffTerminal(
                                                                                i,
                                                                                'TStart' +
                                                                                    i,

                                                                                'TEnd' +
                                                                                    i
                                                                            )
                                                                        "
                                                                        :id="
                                                                            'TEnd' +
                                                                                i
                                                                        "
                                                                        hide-details
                                                                    ></v-text-field>
                                                                </td>
                                                                <td></td>
                                                                <td
                                                                    style="padding: 6px 0 0;"
                                                                >
                                                                    Station End
                                                                </td>
                                                                <td
                                                                    v-show="
                                                                        order.showStEnd
                                                                    "
                                                                >
                                                                    <p
                                                                        @click="
                                                                            order.showStEnd = false
                                                                        "
                                                                        :style="
                                                                            order.StEndOrigin ==
                                                                            2
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8A6;'
                                                                                : order.StEndOrigin ==
                                                                                  3
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #80D8D5;'
                                                                                : order.StEndOrigin ==
                                                                                  4
                                                                                ? 'margin: 0;padding: 2px 0 0;width: 140px;background-color: #eff93f;'
                                                                                : 'margin: 0;padding: 2px 0 0;width: 140px;'
                                                                        "
                                                                        v-if="
                                                                            order.StEndDate !=
                                                                                '' &&
                                                                                order.StEndDate !=
                                                                                    null &&
                                                                                order.StEndDate !=
                                                                                    undefined
                                                                        "
                                                                    >
                                                                        {{
                                                                            order.StEndDate
                                                                        }}
                                                                        <strong
                                                                            class="timeLoadValue"
                                                                        >
                                                                            {{
                                                                                order.StEndTime
                                                                            }}
                                                                        </strong>
                                                                    </p>
                                                                    <p
                                                                        v-else
                                                                        @click="
                                                                            order.showStEnd = false
                                                                        "
                                                                        class="replicatePlaceholder"
                                                                    >
                                                                        YYYY-MM-DD
                                                                        HH:MM
                                                                    </p>
                                                                </td>
                                                                <td
                                                                    v-show="
                                                                        !order.showStEnd
                                                                    "
                                                                >
                                                                    <v-text-field
                                                                        autofocus
                                                                        style="
                                                                                font-size: 13px;
                                                                                padding: 0;
                                                                                margin: 0;
                                                                                width: 140px;
                                                                            "
                                                                        placeholder="YYYY-MM-DD HH:MM"
                                                                        v-mask="
                                                                            '####-##-## ##:##'
                                                                        "
                                                                        @focus="
                                                                            notSaveLoad(
                                                                                'StEnd' +
                                                                                    i
                                                                            )
                                                                        "
                                                                        @blur="
                                                                            calculateDiffStation(
                                                                                i,
                                                                                'StStart' +
                                                                                    i,
                                                                                'StEnd' +
                                                                                    i
                                                                            )
                                                                        "
                                                                        @change="
                                                                            saveOrderDates(
                                                                                'StEnd',
                                                                                i,
                                                                                order
                                                                            )
                                                                        "
                                                                        dense
                                                                        type="tel"
                                                                        :rules="
                                                                            dateRules
                                                                        "
                                                                        :value="
                                                                            order.StEnd
                                                                        "
                                                                        :id="
                                                                            'StEnd' +
                                                                                i
                                                                        "
                                                                        hide-details
                                                                    ></v-text-field>
                                                                </td>
                                                                <td
                                                                    colspan="2"
                                                                ></td>
                                                                <td colspan="1">
                                                                    <v-icon
                                                                        color="red"
                                                                        v-if="
                                                                            order.NoAllocation
                                                                        "
                                                                        >mdi-gas-station-off</v-icon
                                                                    >
                                                                </td>
                                                            </tr>
                                                        </thead>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="comt">
                                            <v-textarea
                                                label="Comments"
                                                v-model="order.GPSComments"
                                                @change="
                                                    saveOrderCommnet(order, i)
                                                "
                                                :id="'CommentLoad' + i"
                                                @focus="
                                                    notSaveLoad(
                                                        'CommentLoad' + i
                                                    )
                                                "
                                                outlined
                                                hide-details
                                                height="100px"
                                            ></v-textarea>
                                        </div>
                                    </div>
                                </v-list-item>
                            </div>
                            <!-- </draggable> -->
                        </v-list>
                    </div>
                </div>
            </div>
        </v-container>

        <!--<v-dialog
            v-model="loadingOrders"
            max-width="900px"
            hide-overlay
            persistent
            transition="dialog-bottom-transition"
        >
            <v-card
                elevation="2"
                outlined
                shaped
                style="padding: 40px;"
            >
                <p style="margin: 0 0 30px 0;font-size: x-large;">
                    Synchronizing data with Geotab...
                </p>
                <v-progress-linear
                    :size="50"
                    color="primary"
                    indeterminate
                ></v-progress-linear>
            </v-card>
        </v-dialog>-->

        <edtProductTracking
            v-if="$store.state.tracking.editProduct"
            :prm="data"
            :idx="index"
        />
        <droppedCK
            v-if="$store.state.tracking.CKDroppedList"
            :ShiftId="comboShiftDates.ShiftId"
        ></droppedCK>

        <TrackingHrs
            v-if="$store.state.tracking.TrackingHrs"
            :ShiftId="comboShiftDates.ShiftId"
        />

        <TrackingDiff
            v-if="$store.state.tracking.TrackingDiff"
            :ShiftId="comboShiftDates.ShiftId"
        >
        </TrackingDiff>
        <pendings
            v-if="$store.state.tracking.pendings"
            :shiftDates="shiftDates"
        ></pendings>
        <totalDropComment
            v-if="$store.state.tracking.totalDrop"
            :Shift="comboShiftDates"
            :Title="titleModal"
        >
        </totalDropComment>

        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
        <alert-dialogue ref="alertDialogue"></alert-dialogue>
    </v-container>
</template>

<!--<script src="https://cdn.jsdelivr.net/npm/mg-api-js"></script>-->
<script>
// import $ from 'jquery';
import axios from 'axios';
import moment from 'moment';
// import draggable from 'vuedraggable';
import edtProductTracking from './../Modals/Dispatch/Tracking/EditProductTracking.vue';
import { mask } from 'vue-the-mask';
import droppedCK from './../Modals/Dispatch/Tracking/DroppedLoad.vue';
import TrackingHrs from './../Modals/Dispatch/Tracking/TrackingHrs.vue';
import TrackingDiff from './../Modals/Dispatch/Tracking/TrackingDiff.vue';
import pendings from './../Modals/Dispatch/Tracking/Pendings.vue';
import totalDropComment from './../Modals/Dispatch/Tracking/TotalDropps&Comments.vue';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';
import AlertDialogue from './../Modals/AlertDialogue.vue';

export default {
    name: 'Tracking',
    components: {
        edtProductTracking,
        droppedCK,
        totalDropComment,
        // draggable,
        pendings,
        TrackingHrs,
        TrackingDiff,
        ConfirmDialogue,
        AlertDialogue
    },
    data: function() {
        return {
            //tripDatapoints: [],
            //geotabApi: null,
            tlpTerminal: false,
            tlpStation: false,
            titleModal: null,
            calculateBarner: null,
            indexShift: 0,
            indexDriver: 0,
            shiftDates: [],
            shiftDetailsDrivers: [],
            UnfinishDate: [],
            finishDate: [],
            allDrivers: [],
            statusFilter: 0,
            comboShiftDates: null,
            comboDrivers: null,
            ShowGPSShiftStart: true,
            ShowGPSShiftEnd: true,
            ShowLogStart: true,
            ShowLogEnd: true,
            GPSShiftStartOrigin: null,
            GPSShiftEndOrigin: null,
            LogStartOrigin: null,
            LogEndOrigin: null,
            shiftDetails: {
                GPSShiftStart: '',
                GPSShiftStartDate: '',
                GPSShiftStartTime: '',
                GPSShiftEnd: '',
                GPSShiftEndDate: '',
                GPSShiftEndTime: '',
                LogStart: '',
                LogStartDate: '',
                LogStartTime: '',
                LogEnd: '',
                LogEndDate: '',
                LogEndTime: ''
            },
            modifiedLoad: false,
            modified: null,
            disabled: false,
            index: 0,
            orderID: null,
            orders: [],
            data: [],
            dialog: false,
            saving: false,
            viewOrders: false,
            loadingOrders: false,
            productsOrder: [],
            headerProducts: [
                { text: 'Product', value: 'Product', width: '2' },
                { text: 'Ord QTY', value: 'Quantity', width: '2' },
                { text: 'Action', value: 'actions', width: '2' },
                { text: 'OrderID', value: 'OrderID', width: '2' }
            ],
            dateRules: [
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[11] + v[12]) <= 24 &&
                        parseInt(v[11] + v[12]) >= 0) ||
                    'Hour Incorrect',
                v =>
                    (parseInt(v[14] + v[15]) <= 59 &&
                        parseInt(v[14] + v[15]) >= 0) ||
                    'Minutes Incorrect'
            ]
        };
    },
    directives: {
        mask
    },
    watch: {
        '$store.state.tracking.editProduct': async function() {
            if (this.$store.state.tracking.watch != null) {
                var idx = this.$store.state.tracking.watch;
                if (this.orders[idx].CKStation == true) {
                    this.orders[idx].btnColor = 'success';
                    var ord = this.orderID;
                    await this.updateOrder(ord);
                    this.orderID = null;
                }
                this.showShiftDetails();
            }
        }
    },
    mounted() {
        var elemento = null;
        //this.authGeotab();
        this.loadShiftDates();
        this.$nextTick(() => {
            document.addEventListener('keyup', e => {
                if (e.ctrlKey && e.keyCode === 38) {
                    //Ctrl + Top Key
                    if (this.modified != null) {
                        elemento = document.getElementById(this.modified);
                        elemento.blur();
                        this.modified = null;
                    } else {
                        if (this.comboShiftDates == null) {
                            this.comboShiftDates = this.shiftDates[0];
                            this.getShiftDetails();
                            this.indexShift = 0;
                        } else if (this.indexShift == 0) {
                            this.$store.dispatch('setSnackbar', {
                                color: 'danger',
                                text: 'No More Shifts Date'
                            });
                        } else if (this.indexShift > 0) {
                            this.comboShiftDates.length == 0;
                            this.indexShift--;
                            this.comboShiftDates = this.shiftDates[
                                this.indexShift
                            ];
                            this.getShiftDetails();
                        }
                    }
                }
                if (e.ctrlKey && e.keyCode === 40) {
                    //Ctrl + Down Key
                    if (this.modified != null) {
                        elemento = document.getElementById(this.modified);
                        elemento.blur();
                        this.modified = null;
                    } else {
                        if (this.comboShiftDates == null) {
                            this.comboShiftDates = this.shiftDates[0];
                            this.getShiftDetails();
                            this.indexShift = 0;
                        } else if (this.indexShift > this.shiftDates.length) {
                            this.$store.dispatch('setSnackbar', {
                                color: 'danger',
                                text: 'No More Shifts Date'
                            });
                        } else if (this.indexShift >= 0) {
                            this.indexShift++;
                            this.comboShiftDates.length == 0;
                            this.comboShiftDates = this.shiftDates[
                                this.indexShift
                            ];
                            this.getShiftDetails();
                        }
                    }
                }
                if (e.ctrlKey && e.keyCode === 37) {
                    //Ctrl + Left Key
                    if (this.comboShiftDates != null) {
                        if (this.modified != null) {
                            elemento = document.getElementById(this.modified);
                            elemento.blur();
                            this.modified = null;
                        } else {
                            if (this.shiftDetailsDrivers.length != 0) {
                                //Ctrl + Top Left
                                if (this.comboDrivers == null) {
                                    this.comboDrivers = this.shiftDetailsDrivers[0];
                                    this.showShiftDetails();
                                    this.indexDriver = 0;
                                } else if (this.indexDriver == 0) {
                                    this.$store.dispatch('setSnackbar', {
                                        color: 'red',
                                        text: 'No More Drivers'
                                    });
                                } else if (this.indexDriver > 0) {
                                    this.comboDrivers.length == 0;
                                    this.indexDriver--;
                                    this.comboDrivers = this.shiftDetailsDrivers[
                                        this.indexDriver
                                    ];
                                    this.showShiftDetails();
                                }
                            } else {
                                this.$store.dispatch('setSnackbar', {
                                    color: 'red',
                                    text: 'Nothing was found!!'
                                });

                                this.$store.state.isLoading = false;
                            }
                        }
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            color: 'red',
                            text: 'Select a Shift!!'
                        });
                    }
                }
                if (e.ctrlKey && e.keyCode === 39) {
                    if (this.modified != null) {
                        console.log(this.modified);
                        elemento = document.getElementById(this.modified);
                        elemento.blur();
                        this.modified = null;
                    } else {
                        if (this.comboShiftDates != null) {
                            if (this.shiftDetailsDrivers.length != 0) {
                                //Ctrl + Right Key
                                if (this.comboDrivers == null) {
                                    this.comboDrivers = this.shiftDetailsDrivers[0];
                                    this.showShiftDetails();
                                    this.indexDriver = 0;
                                    console.log(
                                        this.indexDriver +
                                            ':' +
                                            this.shiftDetailsDrivers.length
                                    );
                                } else if (this.indexDriver >= 0) {
                                    if (
                                        this.indexDriver + 1 ==
                                        this.shiftDetailsDrivers.length
                                    ) {
                                        this.$store.dispatch('setSnackbar', {
                                            color: 'red',
                                            text: 'No More Drivers'
                                        });
                                    } else {
                                        this.indexDriver++;
                                        this.comboDrivers.length == 0;
                                        this.comboDrivers = this.shiftDetailsDrivers[
                                            this.indexDriver
                                        ];
                                        this.showShiftDetails();
                                        console.log(
                                            this.indexDriver +
                                                ':' +
                                                this.shiftDetailsDrivers.length
                                        );
                                    }
                                }
                            } else {
                                this.$store.dispatch('setSnackbar', {
                                    color: 'red',
                                    text: 'Nothing was found!!'
                                });

                                this.$store.state.isLoading = false;
                            }
                        } else {
                            this.$store.dispatch('setSnackbar', {
                                color: 'red',
                                text: 'Select a Shift!!'
                            });
                        }
                    }
                }
            });
        });
    },
    methods: {
        copyPaper: async function(text, from, idx) {
            const delay = ms => new Promise(res => setTimeout(res, ms));
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    console.log('Text copied to clipboard');
                })
                .catch(err => {
                    console.error('Error in copying text: ', err);
                });
            if (from == 'Terminal') {
                this.orders[idx].copyT = true;
                await delay(2000);
                this.orders[idx].copyT = false;
            } else {
                this.orders[idx].copyS = true;
                await delay(2000);
                this.orders[idx].copyS = false;
            }
        },
        notSave: function(prm) {
            this.modified = prm;
            console.log(this.modified);
        },
        notSaveLoad: function(prm) {
            this.modified = prm;
            console.log(prm);
        },
        getTrackingDiff: function() {
            this.$store.state.tracking.TrackingDiff = true;
        },
        getTrackingHrs: function() {
            this.$store.state.tracking.TrackingHrs = true;
        },
        getCKDrop: function() {
            this.$store.state.tracking.CKDroppedList = true;
        },
        getTotalCount: function(parm) {
            this.titleModal = parm;
            this.$store.state.tracking.totalDrop = true;
        },
        onLoadOrderChange: function(order) {
            console.log(order);
            var str = this.$store;
            var params = {
                LoadNum: order.LoadNum,
                LoadNumOrd: order.LoadNumOrd
            };
            axios
                .put('order/' + order.OrderID, params)
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    console.log('Success!');
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Load order changed'
                    });
                })
                .catch(function(error) {
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        filterShDrivers: function() {
            switch (this.statusFilter) {
                case 0:
                    this.shiftDetailsDrivers = this.finishDate;
                    this.statusFilter++;
                    this.$store.dispatch('setSnackbar', {
                        color: 'primary',
                        text: this.shiftDetailsDrivers.length + ' Dispatch Open'
                    });
                    break;
                case 1:
                    this.shiftDetailsDrivers = this.UnfinishDate;
                    this.statusFilter++;
                    this.$store.dispatch('setSnackbar', {
                        color: 'primary',
                        text:
                            this.shiftDetailsDrivers.length + ' Dispatch closed'
                    });
                    break;
                case 2:
                    this.shiftDetailsDrivers = this.allDrivers;
                    this.statusFilter = 0;
                    this.$store.dispatch('setSnackbar', {
                        color: 'primary',
                        text: 'All Dispatch (' + this.allDrivers.length + ')'
                    });
                    break;
            }
        },
        calculateDiffTerminal: function(i, tstart, tend) {
            this.modified = null;
            this.orders[i].showTStart = true;
            this.orders[i].showTEnd = true;
            this.orders[i].timeDiffT = this.getTimeDiff(
                this.getMsk(tstart),
                this.getMsk(tend)
            );
            console.log(this.orders[i].timeDiffT, this.modified);
        },
        calculateDiffStation: function(i, tstart, tend) {
            this.modified = null;
            this.orders[i].showStStart = true;
            this.orders[i].showStEnd = true;
            this.orders[i].timeDiffSt = this.getTimeDiff(
                this.getMsk(tstart),
                this.getMsk(tend)
            );
            console.log(this.orders[i].timeDiffT, this.modified);
        },
        chargeShift: function() {
            var date = moment().format('YYYY-MM-DD') + ' ' + 'PM';
            const index = this.shiftDates.findIndex(elm => {
                return elm.ShiftDate == date;
            });
            this.comboShiftDates = this.shiftDates[index];
            console.log('ComboShifts -',this.comboShiftDates);
            this.getShiftDetails();
        },
        async alertTime(itm) {
            var diff = 0;
            if (itm >= 60) {
                diff = Number(itm / 60).toFixed(2) + ' ' + 'Hours';
            } else if (itm < 20) {
                diff = itm + ' ' + 'Minutes';
            }
            const ok = await this.$refs.alertDialogue.show({
                message: 'Time Difference ',
                highlight: diff
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                console.log(itm);
            }
        },
        openData: function(itm, index) {
            this.data = [];
            this.orderID = null;
            this.$store.state.tracking.watch = null;
            this.index = index;
            this.$store.state.tracking.editProduct = false;
            this.data = itm;
            this.orderID = itm.OrderID;
            this.$store.state.tracking.editProduct = true;
        },
        updateValue: function(prop, value) {
            this.shiftDetails[prop] = value;
        },
        loadShiftDates: function() {
            this.$store.state.isLoading = true;
            axios
                .get('shift-header/dates')
                .then(response => {
                    this.shiftDates = response.data.data;
                    console.log(this.shiftDates);
                    this.chargeShift();
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        getShiftDetails: function() {
            if (this.comboShiftDates != null) {
                this.$store.state.isLoading = true;
                this.indexShift = this.shiftDates.findIndex(elm => {
                    return elm.ShiftId == this.comboShiftDates.ShiftId;
                });
                console.log('indexShift', this.indexShift);
                axios
                    .get('shift-detail/shift/' + this.comboShiftDates.ShiftId, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.comboDrivers = null;
                        this.shiftDetails.GPSShiftStart = '';
                        this.shiftDetails.GPSShiftEnd = '';
                        this.orders = {};
                        this.none();
                        this.viewOrders = false;
                        this.shiftDetailsDrivers = response.data;

                        let filter = this.shiftDetailsDrivers.filter(
                            x => x.GPSShiftEnd === null || x.GPSShiftEnd === ''
                        );
                        this.finishDate = filter;
                        let filter2 = this.shiftDetailsDrivers.filter(
                            x => x.GPSShiftEnd != null
                        );
                        console.log(filter.length, filter2.length);
                        this.allDrivers = response.data;
                        this.UnfinishDate = filter2;
                        console.log(
                            'This.ComboDrivers',
                            this.shiftDetailsDrivers
                        );
                        this.$store.state.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log(error);

                        this.$store.state.isLoading = false;
                    });
            }
        },
        /*getGeotabTripHistory: async function() {
            console.log("getGeotabTripHistory");
            console.log(this.shiftDetails);

            let shiftDate = moment(this.shiftDetails.ShiftDate);
            let updatedDate = shiftDate.add(1, 'day');
            let toDate = updatedDate.format('YYYY-MM-DD');
            console.log(toDate);

            await this.geotabApi
                .call('Get',
                    {
                        typeName: 'Trip',
                        search: {
                            fromDate: this.shiftDetails.ShiftDate,
                            toDate: toDate,
                            userSearch: { id: this.shiftDetails.DriverGeotabID }
                        }
                })
                .then( async result => {
                    console.log(result);
                    let trips = result;
                    await this.getZoneByTrip(trips);
                })
                .catch( error => {
                    console.log(error);
                });
        },*/
        /*getZoneByTrip: async function (trips) {
            console.log("getZoneByTrip");
            let tripData = [];
            for (let t of trips) {
                await this.geotabApi
                    .call('GetAddresses',
                        {
                            coordinates: [{
                                x: t.stopPoint.x,
                                y: t.stopPoint.y
                            }],
                    })
                    .then( result => {
                        //console.log(result);
                        let areaFound = result[0];
                        tripData.push({
                            TripGeotabID: t.id,
                            TruckGeotabID: t.device.id,
                            DriverGeotabID: t.driver.id,
                            FromDate: this.shiftDetails.ShiftDate,
                            StartTime: t.start,
                            StopTime: t.stop,
                            NextStartTime: t.nextTripStart,
                            StopDuration: t.stopDuration,
                            StopZoneGeotabID: areaFound.zones ? areaFound.zones[0].id : 'UnknownZone',
                        });
                    })
                    .catch( error => {
                        console.log(error);
                    });
            }
            for (let trip of tripData) {
                trip.StartTime = this.setDateTime(trip.StartTime);
                trip.StopTime = this.setDateTime(trip.StopTime);
                trip.NextStartTime = this.setDateTime(trip.NextStartTime);
            }
            console.log(tripData);
            //this.clearTripData(tripData);
            this.tripDatapoints = tripData;
            //await this.updateGeotabTripHistory(tripData);
        },*/
        /*clearTripData: function (tripData) {
            let cleanTripData = [];
            let newCleanTripData = [];

            for (let t of tripData) {
                cleanTripData.push({
                    StopZoneGeotabID: t.StopZoneGeotabID,
                    ArrivalTime: t.StopTime,
                    ExitTime: t.NextStartTime,
                });
            }

            for (let c of cleanTripData) {
                if (c.StopZoneGeotabID == 'UnknownZone') {
                    continue;
                }

                newCleanTripData.push(c);
            }

            this.tripDatapoints = newCleanTripData;
        },*/
        /*updateGeotabTripHistory: async function(tripData) {
            let data = {
                TripData: tripData
            };
            console.log(data);
            await axios
                .post('order/geotab-trip-history/update', data, )
                .then( response => {
                    console.log(response.data);
                    this.tripDatapoints = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },*/
        /*setDateTime: function (geotabDatetime) {
            let date = geotabDatetime.split('T')[0];
            let time = geotabDatetime.split('T')[1];
            time = time.split('.')[0];
            let dateTime = date + ' ' + time;
            //console.log(dateTime);
            dateTime = moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
            dateTime = moment(dateTime).subtract(5, 'hours');
            dateTime = dateTime.format('YYYY-MM-DD HH:mm:ss');
            //console.log(dateTime);
            return dateTime;
        },*/
        /*prepareOrderData: function (orders) {
            let orderDatapoints = [];
            for (let ord of orders) {
                if (ord.LoadNumOrd != null && ord.LoadNumOrd > 1) {
                    orderDatapoints.push({
                        OrderID: ord.OrderID,
                        LoadNum: ord.LoadNum,
                        LoadNumOrd: ord.LoadNumOrd,
                        OrderZoneGeotabID: ord.StationGeotabID,
                        OrderTimestamp: ord.StStart,
                        OrderTimestampOrigin: ord.StStartOrigin,
                    });

                    orderDatapoints.push({
                        OrderID: ord.OrderID,
                        LoadNum: ord.LoadNum,
                        LoadNumOrd: ord.LoadNumOrd,
                        OrderZoneGeotabID: ord.StationGeotabID,
                        OrderTimestamp: ord.StEnd,
                        OrderTimestampOrigin: ord.StEndOrigin,
                    });
                } else {
                    orderDatapoints.push({
                        OrderID: ord.OrderID,
                        LoadNum: ord.LoadNum,
                        LoadNumOrd: ord.LoadNumOrd,
                        OrderZoneGeotabID: ord.TerminalGeotabID,
                        OrderTimestamp: ord.TStart,
                        OrderTimestampOrigin: ord.TStartOrigin,
                    });

                    orderDatapoints.push({
                        OrderID: ord.OrderID,
                        LoadNum: ord.LoadNum,
                        LoadNumOrd: ord.LoadNumOrd,
                        OrderZoneGeotabID: ord.TerminalGeotabID,
                        OrderTimestamp: ord.TEnd,
                        OrderTimestampOrigin: ord.TEndOrigin,
                    });

                    orderDatapoints.push({
                        OrderID: ord.OrderID,
                        LoadNum: ord.LoadNum,
                        LoadNumOrd: ord.LoadNumOrd,
                        OrderZoneGeotabID: ord.StationGeotabID,
                        OrderTimestamp: ord.StStart,
                        OrderTimestampOrigin: ord.StStartOrigin,
                    });

                    orderDatapoints.push({
                        OrderID: ord.OrderID,
                        LoadNum: ord.LoadNum,
                        LoadNumOrd: ord.LoadNumOrd,
                        OrderZoneGeotabID: ord.StationGeotabID,
                        OrderTimestamp: ord.StEnd,
                        OrderTimestampOrigin: ord.StEndOrigin,
                    });
                }
            }

            console.log(orderDatapoints);
            return orderDatapoints;
        },*/
        /*prepareTripData: function (orders) {
            let orderZoneGeotabIDs = [];
            for (let ord of orders) {
                orderZoneGeotabIDs.push(ord.TerminalGeotabID);
                orderZoneGeotabIDs.push(ord.StationGeotabID);
            }
            console.log(orderZoneGeotabIDs);

            let uqOrderZoneGeotabIDs = orderZoneGeotabIDs.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });
            console.log(uqOrderZoneGeotabIDs);

            console.log(this.tripDatapoints);
            let tripDatapoints = [];
            for (let t of this.tripDatapoints) {
                for (let id of uqOrderZoneGeotabIDs) {
                    if (t.StopZoneGeotabID == id) {
                        tripDatapoints.push(t);
                        break;
                    }
                }
            }
            console.log(tripDatapoints);

            let newTripDatapoints = [];
            for (let t = 0; t < tripDatapoints.length; t++) {
                if (
                    (
                        t == 0 &&
                        tripDatapoints[t].StopZoneGeotabID != tripDatapoints[t+1].StopZoneGeotabID
                    ) ||
                    (
                        t > 0 && t < tripDatapoints.length-1 &&
                        (
                            tripDatapoints[t].StopZoneGeotabID != tripDatapoints[t+1].StopZoneGeotabID ||
                            tripDatapoints[t].StopZoneGeotabID != tripDatapoints[t-1].StopZoneGeotabID
                        )
                    ) ||
                    (
                        t == tripDatapoints.length-1 &&
                        tripDatapoints[t].StopZoneGeotabID != tripDatapoints[t-1].StopZoneGeotabID
                    )
                ) {
                    newTripDatapoints.push(tripDatapoints[t]);
                }
            }

            console.log("newTripDatapoints: ", newTripDatapoints);
            this.tripDatapoints = newTripDatapoints;
        },*/
        //setGeotabTimestamps: async function(orders) {
        //console.log("setGeotabTimestamps");
        //this.prepareTripData(orders);
        //let orderDatapoints = this.prepareOrderData(orders);
        //let lastTrip = null;
        //let nextOrderControl = false;

        /*for (let o of orders) {
                o.OrderProcessed = false;
            }*/

        //for (let t of this.tripDatapoints) {
        // New New Logic
        /*if (
                    t == 0 &&
                    this.tripDatapoints[t].StopZoneGeotabID != this.tripDatapoints[t+1].StopZoneGeotabID
                ) {
                    // code here
                } else if (
                    t > 0 && t < this.tripDatapoints.length-1 &&
                    (
                        this.tripDatapoints[t].StopZoneGeotabID != this.tripDatapoints[t+1].StopZoneGeotabID ||
                        this.tripDatapoints[t].StopZoneGeotabID != this.tripDatapoints[t-1].StopZoneGeotabID
                    )
                ) {
                    // code here
                } else if (
                    t == this.tripDatapoints.length-1 &&
                    this.tripDatapoints[t].StopZoneGeotabID != this.tripDatapoints[t-1].StopZoneGeotabID
                ) {
                    // code here
                }

                if (
                    orderDatapoints[t].OrderZoneGeotabID == this.tripDatapoints[t].StopZoneGeotabID &&
                    orderDatapoints[t].OrderTimestampOrigin != 2
                ) {
                    orderDatapoints[t].OrderTimestamp = this.tripDatapoints[t].ArrivalTime;
                    orderDatapoints[t].OrderTimestampOrigin = 2;
                    this.tripDatapoints[t].Processed = true;
                }*/

        /*for (let ord of orders) {
                    if (ord.OrderProcessed) {
                        continue;
                    }

                    if (
                        // If the first stop is the terminal
                        lastTrip == null &&
                        t.StopZoneGeotabID == ord.TerminalGeotabID &&
                        ord.TStartOrigin != 2
                    ) {
                        ord.TStart = t.StopTime;
                        ord.TStartOrigin = 2;
                        break;
                    } else if (lastTrip != null) {
                        if (
                            nextOrderControl &&
                            lastTrip.StopZoneGeotabID == ord.TerminalGeotabID &&
                            ord.TStartOrigin != 2
                        ) {
                            ord.TStart = lastTrip.StopTime;
                            ord.TStartOrigin = 2;
                            nextOrderControl = false;

                            if (
                                t.StopZoneGeotabID == ord.StationGeotabID &&
                                ord.StStartOrigin != 2
                            ) {
                                ord.StStart = t.StopTime;
                                ord.StStartOrigin = 2;

                                ord.TEnd = t.StartTime;
                                ord.TEndOrigin = 2;
                            }

                            break;
                        } else if (
                            // There was a change from the last stop to the terminal (TStart)
                            t.StopZoneGeotabID == ord.TerminalGeotabID &&
                            lastTrip.StopZoneGeotabID != ord.TerminalGeotabID &&
                            ord.TStartOrigin != 2
                        ) {
                            ord.TStart = t.StopTime;
                            ord.TStartOrigin = 2;
                            break;
                        } else if (
                            // There was a change from the last stop (terminal) to the current stop (TEnd)
                            lastTrip.StopZoneGeotabID != t.StopZoneGeotabID &&
                            lastTrip.StopZoneGeotabID == ord.TerminalGeotabID &&
                            ord.TEndOrigin != 2
                        ) {
                            ord.TEnd = t.StartTime;
                            ord.TEndOrigin = 2;

                            if (
                                // In the current trip check for the Station to verify the StStart
                                t.StopZoneGeotabID == ord.StationGeotabID &&
                                ord.StStartOrigin != 2
                            ) {
                                ord.StStart = t.StopTime;
                                ord.StStartOrigin = 2;
                            }

                            break;
                        } else if (
                            // There was a change from the last stop (station) to the current stop (StEnd)
                            lastTrip.StopZoneGeotabID != t.StopZoneGeotabID &&
                            lastTrip.StopZoneGeotabID == ord.StationGeotabID &&
                            ord.StEndOrigin != 2
                        ) {
                            ord.StEnd = t.StartTime;
                            ord.StEndOrigin = 2;
                            ord.OrderProcessed = true;
                            nextOrderControl = true;
                            break;
                        } else if (
                            // There was a change from the last stop to the station (StStart)
                            t.StopZoneGeotabID == ord.StationGeotabID &&
                            lastTrip.StopZoneGeotabID != ord.StationGeotabID &&
                            ord.StStartOrigin != 2
                        ) {
                            ord.StStart = t.StopTime;
                            ord.StStartOrigin = 2;
                            break;
                        }
                    } else {
                        break;
                    }
                }

                lastTrip = t;
            }

            return orders;
        },*/
        /*updateProcessedGeotabData: function(orders) {
            let params = {
                Orders: orders,
                Trips: this.tripDatapoints,
                //ShiftData: this.shiftDetails,
            };
            axios
                .put('order/update/processed-geotab-data', params, )
                .then(response => {
                    console.log(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },*/
        updateShiftHrs: function() {
            axios
                .post(
                    'order/recalculateTimes/' + this.shiftDetails.ShiftDetail,
                    {},
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                )
                .then(response => {
                    console.log('Here', response.data);
                    if (response.data.length > 1) {
                        var gpsTime = response.data[0].GPSShiftEnd;
                        this.shiftDetails.GPSShiftEnd = gpsTime;
                        this.shiftDetails.GPSShiftEndDate = this.shiftDetails.GPSShiftEnd.split(
                            ' '
                        )[0];
                        this.shiftDetails.GPSShiftEndTime = this.shiftDetails.GPSShiftEnd.split(
                            ' '
                        )[1];
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getOrdersByShiftDetail: async function() {
            this.loadingOrders = true;
            //await this.getGeotabTripHistory();
            //console.log("tripDatapoints: ", this.tripDatapoints);
            this.$store.state.isLoading = true;
            if (this.getMsk('LogStart') != '') {
                // await axios
                //     .post(
                //         'order/recalculateTimes/' +
                //             this.shiftDetails.ShiftDetail,
                //         {},
                //         {
                //             headers: {
                //                 Authorization:
                //                     'Bearer ' + this.$store.state.token
                //             }
                //         }
                //     )
                //     .then(response => {
                //         if (response.data.length > 1) {
                //             var data = response.data[0];

                //             if (data.GPSShiftStart) {
                //                 this.shiftDetails.GPSShiftStart =
                //                     data.GPSShiftStart;
                //                 this.shiftDetails.GPSShiftStartDate = this.shiftDetails.GPSShiftStart.split(
                //                     ' '
                //                 )[0];
                //                 this.shiftDetails.GPSShiftStartTime = this.shiftDetails.GPSShiftStart.split(
                //                     ' '
                //                 )[1];
                //             }

                //             var gpsTime = data.GPSShiftEnd;
                //             if (gpsTime) {
                //                 this.shiftDetails.GPSShiftEnd = gpsTime;
                //                 this.shiftDetails.GPSShiftEndDate = this.shiftDetails.GPSShiftEnd.split(
                //                     ' '
                //                 )[0];
                //                 this.shiftDetails.GPSShiftEndTime = this.shiftDetails.GPSShiftEnd.split(
                //                     ' '
                //                 )[1];
                //             }

                //             if (data.LogEnd) {
                //                 this.shiftDetails.LogEnd = data.LogEnd;
                //                 this.shiftDetails.LogEndDate = this.shiftDetails.LogEnd.split(
                //                     ' '
                //                 )[0];
                //                 this.shiftDetails.LogEndTime = this.shiftDetails.LogEnd.split(
                //                     ' '
                //                 )[1];
                //             }

                //             // data.LogEnd = this.dateFormatDateTimeLocal(data.LogEnd);
                //             // if (data.LogEnd) {
                //             //     data.LogEndDate = data.LogEnd.split('T')[0];
                //             //     data.LogEndTime = data.LogEnd.split('T')[1];
                //             // }

                //             // data.GPSShiftEnd = this.dateFormatDateTimeLocal(data.GPSShiftEnd);
                //             // if (data.GPSShiftEnd) {
                //             //     data.GPSShiftEndDate = data.GPSShiftEnd.split('T')[0];
                //             //     data.GPSShiftEndTime = data.GPSShiftEnd.split('T')[1];
                //             // }
                //         }
                //     })
                //     .catch(function(error) {
                //         console.log(error);
                //     });
            }
            await axios
                .get('order/shift/' + this.shiftDetails.ShiftDetail)
                .then(async response => {
                    var temp_orders = response.data;
                    //temp_orders = await this.setGeotabTimestamps(temp_orders);
                    this.loadingOrders = false;
                    //this.updateProcessedGeotabData(temp_orders);
                    var font = 'tbDarkFont';
                    console.log('temp_orders: ', temp_orders);
                    //console.log("tripDatapoints: ", this.tripDatapoints);
                    if (temp_orders) {
                        temp_orders.forEach((e, i) => {
                            if (temp_orders[i].RTTime) {
                                temp_orders[i].RTTimeDate = temp_orders[
                                    i
                                ].RTTime.split(' ')[0];
                                temp_orders[i].RTTimeTime = temp_orders[
                                    i
                                ].RTTime.split(' ')[1];
                                temp_orders[i].RTTimeTime = temp_orders[
                                    i
                                ].RTTimeTime.substring(
                                    0,
                                    temp_orders[i].RTTimeTime.lastIndexOf(':')
                                );
                            }

                            if (temp_orders[i].ROTime) {
                                temp_orders[i].ROTimeDate = temp_orders[
                                    i
                                ].ROTime.split(' ')[0];
                                temp_orders[i].ROTimeTime = temp_orders[
                                    i
                                ].ROTime.split(' ')[1];
                                temp_orders[i].ROTimeTime = temp_orders[
                                    i
                                ].ROTimeTime.substring(
                                    0,
                                    temp_orders[i].ROTimeTime.lastIndexOf(':')
                                );
                            }

                            if (temp_orders[i].ETATime) {
                                temp_orders[i].ETATimeDate = temp_orders[
                                    i
                                ].ETATime.split(' ')[0];
                                temp_orders[i].ETATimeTime = temp_orders[
                                    i
                                ].ETATime.split(' ')[1];
                                temp_orders[i].ETATimeTime = temp_orders[
                                    i
                                ].ETATimeTime.substring(
                                    0,
                                    temp_orders[i].ETATimeTime.lastIndexOf(':')
                                );
                            }
                            if (temp_orders[i].GoalPostTime) {
                                temp_orders[i].GoalPostDate = temp_orders[
                                    i
                                ].GoalPostTime.split(' ')[0];
                                temp_orders[i].GoalPostTimeTime = temp_orders[
                                    i
                                ].GoalPostTime.split(' ')[1];
                            }

                            temp_orders[i].showTStart = true;
                            temp_orders[
                                i
                            ].TStart = this.dateFormatDateTimeLocal(
                                temp_orders[i].TStart
                            );
                            if (temp_orders[i].TStart) {
                                temp_orders[i].TStartDate = temp_orders[
                                    i
                                ].TStart.split('T')[0];
                                temp_orders[i].TStartTime = temp_orders[
                                    i
                                ].TStart.split('T')[1];
                            }

                            temp_orders[i].showTEnd = true;
                            temp_orders[i].TEnd = this.dateFormatDateTimeLocal(
                                temp_orders[i].TEnd
                            );
                            if (temp_orders[i].TEnd) {
                                temp_orders[i].TEndDate = temp_orders[
                                    i
                                ].TEnd.split('T')[0];
                                temp_orders[i].TEndTime = temp_orders[
                                    i
                                ].TEnd.split('T')[1];
                            }

                            temp_orders[i].showStStart = true;
                            temp_orders[
                                i
                            ].StStart = this.dateFormatDateTimeLocal(
                                temp_orders[i].StStart
                            );
                            if (temp_orders[i].StStart) {
                                temp_orders[i].StStartDate = temp_orders[
                                    i
                                ].StStart.split('T')[0];
                                temp_orders[i].StStartTime = temp_orders[
                                    i
                                ].StStart.split('T')[1];
                            }

                            temp_orders[i].showStEnd = true;
                            temp_orders[i].StEnd = this.dateFormatDateTimeLocal(
                                temp_orders[i].StEnd
                            );
                            if (temp_orders[i].StEnd) {
                                temp_orders[i].StEndDate = temp_orders[
                                    i
                                ].StEnd.split('T')[0];
                                temp_orders[i].StEndTime = temp_orders[
                                    i
                                ].StEnd.split('T')[1];
                            }

                            temp_orders[i].timeDiffT = this.getTimeDiff(
                                temp_orders[i].TStart,
                                temp_orders[i].TEnd
                            );
                            temp_orders[i].timeDiffSt = this.getTimeDiff(
                                temp_orders[i].StStart,
                                temp_orders[i].StEnd
                            );
                            var ck =
                                temp_orders[i].Station[0] +
                                temp_orders[i].Station[1];

                            if (ck === 'CK') {
                                temp_orders[i].CKStation = true;
                            } else {
                                temp_orders[i].CKStation = false;
                            }

                            if (
                                temp_orders[i].dropped == null ||
                                temp_orders[i].dropped == 0
                            ) {
                                temp_orders[i].btnColor = 'primary';
                            } else {
                                temp_orders[i].btnColor = 'success';
                            }

                            if (font == 'tbFont') {
                                temp_orders[i].tbFont = font;
                                temp_orders[i].rowsCtm = 'rowsCtm mb-1';
                                font = 'tbDarkFont';
                            } else {
                                temp_orders[i].tbFont = font;
                                font = 'tbFont';
                                temp_orders[i].rowsCtm = 'rowsDarkCtm mb-1';
                            }

                            temp_orders[i].copyT = false;
                            temp_orders[i].copyS = false;
                            this.loadProductsOrder(temp_orders[i].OrderID);
                            temp_orders[i].saving = false;
                        });
                    }

                    this.orders = temp_orders;
                    console.log(this.orders);
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },

        showShiftDetails: async function() {
            this.ShowGPSShiftStart = true;
            this.ShowGPSShiftEnd = true;
            this.ShowLogStart = true;
            this.ShowLogEnd = true;
            this.GPSShiftStartOrigin = null;
            this.GPSShiftEndOrigin = null;
            this.LogStartOrigin = null;
            this.LogEndOrigin = null;
            console.log('into showShiftDetails');
            if (this.comboDrivers != null) {
                this.$store.state.isLoading = true;
                this.indexDriver = this.shiftDetailsDrivers.findIndex(elm => {
                    return elm.ShiftDetail == this.comboDrivers.ShiftDetail;
                });
                this.$store.state.isLoading = true;
                var data = this.comboDrivers;
                this.GPSShiftStartOrigin = data.GPSShiftStartOrigin;
                this.GPSShiftEndOrigin = data.GPSShiftEndOrigin;
                this.LogStartOrigin = data.LogStartOrigin;
                this.LogEndOrigin = data.LogEndOrigin;

                data.GPSShiftStart = this.dateFormatDateTimeLocal(
                    data.GPSShiftStart
                );
                if (data.GPSShiftStart) {
                    data.GPSShiftStartDate = data.GPSShiftStart.split('T')[0];
                    data.GPSShiftStartTime = data.GPSShiftStart.split('T')[1];
                }

                data.LogStart = this.dateFormatDateTimeLocal(data.LogStart);
                if (data.LogStart) {
                    data.LogStartDate = data.LogStart.split('T')[0];
                    data.LogStartTime = data.LogStart.split('T')[1];
                }

                data.LogEnd = this.dateFormatDateTimeLocal(data.LogEnd);
                if (data.LogEnd) {
                    data.LogEndDate = data.LogEnd.split('T')[0];
                    data.LogEndTime = data.LogEnd.split('T')[1];
                }

                data.GPSShiftEnd = this.dateFormatDateTimeLocal(
                    data.GPSShiftEnd
                );
                if (data.GPSShiftEnd) {
                    data.GPSShiftEndDate = data.GPSShiftEnd.split('T')[0];
                    data.GPSShiftEndTime = data.GPSShiftEnd.split('T')[1];
                }

                this.shiftDetails = data;
                console.log(this.shiftDetails);
                if (this.shiftDetails.GPSShiftStart != '') {
                    this.calculateBarner = moment(
                        this.shiftDetails.GPSShiftStart
                    ).format('YYYY-MM-DD HH:mm');
                }
                console.log('this.this', this.calculateBarner);
                this.orders = {};
                this.none();
                this.viewOrders = false;
                await this.getOrdersByShiftDetail();
                this.$store.state.isLoading = false;
            }
        },
        downloadDiffHoursReport: function() {
            if (this.comboShiftDates.ShiftId == undefined) {
                this.$store.dispatch('setSnackbar', {
                    color: 'success',
                    text: 'Please select a shift'
                });
            } else {
                var parms = {
                    ShiftId: this.comboShiftDates.ShiftId
                };
                axios
                    .post('shift-detail/difference', parms, {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        var fileName = 'Diff Hours Report' + '.xlsx';
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        console.log(this.startDate);
                        document.body.appendChild(link);
                        link.click();
                        this.$store.state.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log(error);
                        this.$store.state.isLoading = false;
                    });
            }
        },
        savePrevError: function(from, date, idx) {
            var str = this.$store;
            var parms = {
                From: from,
                Order: this.orders[idx].OrderID,
                User: null,
                Date: date
            };
            axios
                .post('pre-error-tracking', parms)
                // eslint-disable-next-line no-unused-vars
                .then(async response => {})
                .catch(error => {
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    str.state.isLoading = false;
                    console.log(error);
                });
        },
        saveChangeShift: function(flag) {
            var params = {};
            var GPSShiftStart = this.getMsk('GPSShiftStart');
            var GPSShiftEnd = this.getMsk('GPSShiftEnd');
            var LogStart = this.getMsk('LogStart');
            var LogEnd = this.getMsk('LogEnd');
            var GPSComments = this.shiftDetails.GPSComments;
            switch (flag) {
                case 'GPSShiftStart':
                    params = {
                        GPSShiftStart: GPSShiftStart,
                        GPSShiftStartOrigin: 3
                    };
                    this.saveShiftDetails(params, flag);
                    break;
                case 'GPSShiftEnd':
                    params = {
                        GPSShiftEnd: GPSShiftEnd,
                        GPSShiftEndOrigin: 3
                    };
                    this.saveShiftDetails(params, flag);
                    break;
                case 'LogStart':
                    params = {
                        LogStart: LogStart,
                        LogStartOrigin: 3
                    };
                    this.saveShiftDetails(params, flag);
                    break;
                case 'LogEnd':
                    params = {
                        LogEnd: LogEnd,
                        LogEndOrigin: 3
                    };
                    this.saveShiftDetails(params, flag);
                    break;
                case 'PostTrip':
                    params = {
                        PostTrip: this.shiftDetails.PostTrip
                    };
                    this.saveShiftDetails(params, flag);
                    break;
                case 'PreTrip':
                    params = {
                        PreTrip: this.shiftDetails.PreTrip
                    };
                    this.saveShiftDetails(params, flag);
                    break;
                case 'GPSComments':
                    params = {
                        GPSComments: GPSComments
                    };
                    this.saveShiftDetails(params, flag);
                    break;
            }
        },
        saveShiftDetails: function(params, flag) {
            this.$store.state.isLoading = true;
            //   const delay = ms => new Promise(res => setTimeout(res, ms));
            //   let index = this.indexDriver;
            this.saving = true;
            axios
                .put('shift-detail/' + this.shiftDetails.ShiftDetail, params)
                // eslint-disable-next-line no-unused-vars
                .then(async response => {
                    this.shiftDetails.length = 0;
                    this.saving = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: flag + ' Successfully updated.'
                    });
                    console.log(response.data);
                    if(flag != 'GPSComments' || flag != 'PostTrip' || flag != 'PreTrip'){
                        const idx = await this.markDates(this.shiftDetails.ShiftDetail);
                        this.shiftDetailsDrivers[idx][flag + 'Origin'] = 3;
                    }
                    this.shiftDetails.GPSComments = response.data.GPSComments;

                    this.shiftDetails.GPSShiftStart = 
                        response.data.GPSShiftStart;
                    if (
                        this.shiftDetails.GPSShiftStart != '' &&
                        this.shiftDetails.GPSShiftStart != null &&
                        this.shiftDetails.GPSShiftStart != undefined
                    ) {
                        this.shiftDetails.GPSShiftStartDate = this.shiftDetails.GPSShiftStart.split(
                            ' '
                        )[0];
                        this.shiftDetails.GPSShiftStartTime = this.shiftDetails.GPSShiftStart.split(
                            ' '
                        )[1];
                    }

                    this.shiftDetails.LogStart = response.data.LogStart;
                    if (
                        this.shiftDetails.LogStart != '' &&
                        this.shiftDetails.LogStart != null &&
                        this.shiftDetails.LogStart != undefined
                    ) {
                        this.shiftDetails.LogStartDate = this.shiftDetails.LogStart.split(
                            ' '
                        )[0];
                        this.shiftDetails.LogStartTime = this.shiftDetails.LogStart.split(
                            ' '
                        )[1];
                    }

                    this.shiftDetails.GPSShiftEnd = response.data.GPSShiftEnd;
                    if (
                        this.shiftDetails.GPSShiftEnd != '' &&
                        this.shiftDetails.GPSShiftEnd != null &&
                        this.shiftDetails.GPSShiftEnd != undefined
                    ) {
                        this.shiftDetails.GPSShiftEndDate = this.shiftDetails.GPSShiftEnd.split(
                            ' '
                        )[0];
                        this.shiftDetails.GPSShiftEndTime = this.shiftDetails.GPSShiftEnd.split(
                            ' '
                        )[1];
                    }

                    this.shiftDetails.LogEnd = response.data.LogEnd;
                    if (
                        this.shiftDetails.LogEnd != '' &&
                        this.shiftDetails.LogEnd != null &&
                        this.shiftDetails.LogEnd != undefined
                    ) {
                        this.shiftDetails.LogEndDate = this.shiftDetails.LogEnd.split(
                            ' '
                        )[0];
                        this.shiftDetails.LogEndTime = this.shiftDetails.LogEnd.split(
                            ' '
                        )[1];
                    }

                    if (flag == 'GPSShiftStart') {
                        this.GPSShiftStartOrigin =
                            response.data.GPSShiftStartOrigin;

                        if (this.shiftDetails.GPSShiftEndTime) {
                            this.shiftDetails.GPSShiftEndTime = this.shiftDetails.GPSShiftEndTime.substring(
                                0,
                                this.shiftDetails.GPSShiftEndTime.lastIndexOf(
                                    ':'
                                )
                            );
                        }

                        if (this.shiftDetails.LogStartTime) {
                            this.shiftDetails.LogStartTime = this.shiftDetails.LogStartTime.substring(
                                0,
                                this.shiftDetails.LogStartTime.lastIndexOf(':')
                            );
                        }

                        if (this.shiftDetails.LogEndTime) {
                            this.shiftDetails.LogEndTime = this.shiftDetails.LogEndTime.substring(
                                0,
                                this.shiftDetails.LogEndTime.lastIndexOf(':')
                            );
                        }
                    } else if (flag == 'GPSShiftEnd') {
                        this.GPSShiftEndOrigin =
                            response.data.GPSShiftEndOrigin;

                        if (this.shiftDetails.GPSShiftStartTime) {
                            this.shiftDetails.GPSShiftStartTime = this.shiftDetails.GPSShiftStartTime.substring(
                                0,
                                this.shiftDetails.GPSShiftStartTime.lastIndexOf(
                                    ':'
                                )
                            );
                        }

                        if (this.shiftDetails.LogStartTime) {
                            this.shiftDetails.LogStartTime = this.shiftDetails.LogStartTime.substring(
                                0,
                                this.shiftDetails.LogStartTime.lastIndexOf(':')
                            );
                        }

                        if (this.shiftDetails.LogEndTime) {
                            this.shiftDetails.LogEndTime = this.shiftDetails.LogEndTime.substring(
                                0,
                                this.shiftDetails.LogEndTime.lastIndexOf(':')
                            );
                        }
                    } else if (flag == 'LogStart') {
                        this.LogStartOrigin = response.data.LogStartOrigin;

                        if (this.shiftDetails.GPSShiftStartTime) {
                            this.shiftDetails.GPSShiftStartTime = this.shiftDetails.GPSShiftStartTime.substring(
                                0,
                                this.shiftDetails.GPSShiftStartTime.lastIndexOf(
                                    ':'
                                )
                            );
                        }

                        if (this.shiftDetails.GPSShiftEndTime) {
                            this.shiftDetails.GPSShiftEndTime = this.shiftDetails.GPSShiftEndTime.substring(
                                0,
                                this.shiftDetails.GPSShiftEndTime.lastIndexOf(
                                    ':'
                                )
                            );
                        }

                        if (this.shiftDetails.LogEndTime) {
                            this.shiftDetails.LogEndTime = this.shiftDetails.LogEndTime.substring(
                                0,
                                this.shiftDetails.LogEndTime.lastIndexOf(':')
                            );
                        }
                    } else if (flag == 'LogEnd') {
                        this.LogEndOrigin = response.data.LogEndOrigin;

                        if (this.shiftDetails.GPSShiftStartTime) {
                            this.shiftDetails.GPSShiftStartTime = this.shiftDetails.GPSShiftStartTime.substring(
                                0,
                                this.shiftDetails.GPSShiftStartTime.lastIndexOf(
                                    ':'
                                )
                            );
                        }

                        if (this.shiftDetails.LogStartTime) {
                            this.shiftDetails.LogStartTime = this.shiftDetails.LogStartTime.substring(
                                0,
                                this.shiftDetails.LogStartTime.lastIndexOf(':')
                            );
                        }

                        if (this.shiftDetails.GPSShiftEndTime) {
                            this.shiftDetails.GPSShiftEndTime = this.shiftDetails.GPSShiftEndTime.substring(
                                0,
                                this.shiftDetails.GPSShiftEndTime.lastIndexOf(
                                    ':'
                                )
                            );
                        }
                    }
                    if (flag == 'GPSShiftStart') {
                        this.updateLoadOrder();
                    }
                    //   await this.getShiftDetails();
                    // this.comboDrivers = this.shiftDetailsDrivers[index];
                    //await this.showShiftDetails();

                    console.log('This.ComboDrivers', this.comboDrivers);

                    this.$store.state.isLoading = false;
                })
                .catch(error => {
                    this.saving = false;
                    this.$store.dispatch('setSnackbar', {
                        color: 'error',
                        text: 'An error has ocurred, please try again.'
                    });
                    this.$store.state.isLoading = false;
                    console.log(error);
                });
        },
        markDates:async function(shiftdetail){
            const x = await this.shiftDetailsDrivers.findIndex( x => {
                return x.ShiftDetail == shiftdetail;
            });
            return x;
        },
        saveOrderDates: function(flag, idx, order) {
            var TStart = this.getMsk('TStart' + idx);
            var TEnd = this.getMsk('TEnd' + idx);
            var StStart = this.getMsk('StStart' + idx);
            var StEnd = this.getMsk('StEnd' + idx);
            var StEndLast = null;
            if (idx > 0) {
                const last = idx - 1;
                StEndLast = this.getMsk('StEnd' + last);
            }

            var params = {};
            if (
                this.shiftDetails.GPSShiftStart == '' ||
                this.shiftDetails.GPSShiftStart == null
            ) {
                this.$store.dispatch('setSnackbar', {
                    color: 'red',
                    text: 'Please enter GPSShiftStart'
                });
            } else {
                switch (flag) {
                    case 'TStart':
                        // console.log(TStart, StEndLast);
                        // if (StEndLast > TStart) {
                        //     this.$store.dispatch('setSnackbar', {
                        //         color: 'red',
                        //         text: 'Enter dates correctly!!'
                        //     });
                        //     this.savePrevError('TStart', TStart, idx);
                        // } else {
                            params = {
                                TStart: TStart,
                                TStartOrigin: 3
                            };
                            if (idx > 0) {
                                const x = moment(TStart).diff(
                                    moment(StEndLast),
                                    'minutes'
                                );
                                if (x < 20 || x >= 60) {
                                    this.alertTime(x);
                                }
                            }
                            this.saveOrderChange(params, idx, order, flag);
                        // }
                        break;
                    case 'TEnd':
                        // if (TStart > TEnd && TStart != '' && TEnd != '') {
                        //     this.$store.dispatch('setSnackbar', {
                        //         color: 'red',
                        //         text: 'Enter dates correctly!!'
                        //     });

                        //     this.savePrevError('TEnd', TEnd, idx);
                        // } else {
                            params = {
                                TEnd: TEnd,
                                TEndOrigin: 3
                            };
                            this.saveOrderChange(params, idx, order, flag);
                        // }
                        break;
                    case 'StStart':
                        // if (TEnd > StStart) {
                        //     this.$store.dispatch('setSnackbar', {
                        //         color: 'red',
                        //         text: 'Enter dates correctly!!'
                        //     });
                        //     this.savePrevError('StStart', StStart, idx);
                        // } else {
                            params = {
                                StStart: StStart,
                                StStartOrigin: 3
                            };
                            const x = moment(StStart).diff(
                                moment(TEnd),
                                'minutes'
                            );
                            if (x < 20 || x >= 60) {
                                this.alertTime(x);
                            }
                            this.saveOrderChange(params, idx, order, flag);
                        // }
                        break;
                    case 'StEnd':
                        // if (StStart > StEnd && StStart != '' && StEnd != '') {
                        //     this.$store.dispatch('setSnackbar', {
                        //         color: 'red',
                        //         text: 'Enter dates correctly!!'
                        //     });
                        //     this.savePrevError('StEnd', StEnd, idx);
                        // } else {
                            params = {
                                StEnd: StEnd,
                                StEndOrigin: 3
                            };
                            this.saveOrderChange(params, idx, order, flag);
                        // }
                        break;
                }
            }
        },
        saveOrderChange: function(params, index, order, flag) {
            console.log(params);
            var str = this.$store;
            axios
                .put('order/' + order.OrderID, params)
                // eslint-disable-next-line no-unused-vars
                .then(async response => {
                    order.saving = false;
                    console.log('Response', response.data);
                    this.orders[index].TStart = response.data.TStart; //Terminal Start Date
                    if (this.orders[index].TStart) {
                        this.orders[index].TStartDate = this.orders[
                            index
                        ].TStart.split(' ')[0];
                        this.orders[index].TStartTime = this.orders[
                            index
                        ].TStart.split(' ')[1];
                    }

                    this.orders[index].TEnd = response.data.TEnd; //Terminal End Date
                    if (this.orders[index].TEnd) {
                        this.orders[index].TEndDate = this.orders[
                            index
                        ].TEnd.split(' ')[0];
                        this.orders[index].TEndTime = this.orders[
                            index
                        ].TEnd.split(' ')[1];
                    }

                    this.orders[index].StStart = response.data.StStart; //Station Start Date
                    if (this.orders[index].StStart) {
                        this.orders[index].StStartDate = this.orders[
                            index
                        ].StStart.split(' ')[0];
                        this.orders[index].StStartTime = this.orders[
                            index
                        ].StStart.split(' ')[1];
                    }

                    this.orders[index].StEnd = response.data.StEnd; //Station End Date
                    if (this.orders[index].StEnd) {
                        this.orders[index].StEndDate = this.orders[
                            index
                        ].StEnd.split(' ')[0];
                        this.orders[index].StEndTime = this.orders[
                            index
                        ].StEnd.split(' ')[1];
                    }

                    if (flag == 'TStart') {
                        this.orders[index].TStartOrigin =
                            response.data.TStartOrigin;

                        if (this.orders[index].TEndTime) {
                            this.orders[index].TEndTime = this.orders[
                                index
                            ].TEndTime.substring(
                                0,
                                this.orders[index].TEndTime.lastIndexOf(':')
                            );
                        }

                        if (this.orders[index].StStartTime) {
                            this.orders[index].StStartTime = this.orders[
                                index
                            ].StStartTime.substring(
                                0,
                                this.orders[index].StStartTime.lastIndexOf(':')
                            );
                        }

                        if (this.orders[index].StEndTime) {
                            this.orders[index].StEndTime = this.orders[
                                index
                            ].StEndTime.substring(
                                0,
                                this.orders[index].StEndTime.lastIndexOf(':')
                            );
                        }
                    } else if (flag == 'TEnd') {
                        this.orders[index].TEndOrigin =
                            response.data.TEndOrigin;

                        if (this.orders[index].TStartTime) {
                            this.orders[index].TStartTime = this.orders[
                                index
                            ].TStartTime.substring(
                                0,
                                this.orders[index].TStartTime.lastIndexOf(':')
                            );
                        }

                        if (this.orders[index].StStartTime) {
                            this.orders[index].StStartTime = this.orders[
                                index
                            ].StStartTime.substring(
                                0,
                                this.orders[index].StStartTime.lastIndexOf(':')
                            );
                        }

                        if (this.orders[index].StEndTime) {
                            this.orders[index].StEndTime = this.orders[
                                index
                            ].StEndTime.substring(
                                0,
                                this.orders[index].StEndTime.lastIndexOf(':')
                            );
                        }
                    } else if (flag == 'StStart') {
                        this.orders[index].StStartOrigin =
                            response.data.StStartOrigin;

                        if (this.orders[index].TStartTime) {
                            this.orders[index].TStartTime = this.orders[
                                index
                            ].TStartTime.substring(
                                0,
                                this.orders[index].TStartTime.lastIndexOf(':')
                            );
                        }

                        if (this.orders[index].TEndTime) {
                            this.orders[index].TEndTime = this.orders[
                                index
                            ].TEndTime.substring(
                                0,
                                this.orders[index].TEndTime.lastIndexOf(':')
                            );
                        }

                        if (this.orders[index].StEndTime) {
                            this.orders[index].StEndTime = this.orders[
                                index
                            ].StEndTime.substring(
                                0,
                                this.orders[index].StEndTime.lastIndexOf(':')
                            );
                        }
                    } else if (flag == 'StEnd') {
                        this.orders[index].StEndOrigin =
                            response.data.StEndOrigin;

                        if (this.orders[index].TStartTime) {
                            this.orders[index].TStartTime = this.orders[
                                index
                            ].TStartTime.substring(
                                0,
                                this.orders[index].TStartTime.lastIndexOf(':')
                            );
                        }

                        if (this.orders[index].TEndTime) {
                            this.orders[index].TEndTime = this.orders[
                                index
                            ].TEndTime.substring(
                                0,
                                this.orders[index].TEndTime.lastIndexOf(':')
                            );
                        }

                        if (this.orders[index].StStartTime) {
                            this.orders[index].StStartTime = this.orders[
                                index
                            ].StStartTime.substring(
                                0,
                                this.orders[index].StStartTime.lastIndexOf(':')
                            );
                        }
                    }

                    await this.updateLoadByOrders(index);
                    await this.generateParamsETAByOrder(index);
                    console.log('Array Order', this.orders[index]);

                    //  this.orders[]
                    //    await  this.showShiftDetails();
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save ' + flag + ' success'
                    });
                })
                .catch(error => {
                    order.saving = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    console.log(error);
                });
        },

        saveOrderCommnet: function(order, index) {
            var str = this.$store;
            var params = {};

            order.saving = true;
            params = {
                'GPS Comments': order.GPSComments
            };
            axios
                .put('order/' + order.OrderID, params)
                // eslint-disable-next-line no-unused-vars
                .then(async response => {
                    order.saving = false;
                    console.log('Response', response.data);
                    this.orders[index].TStart = response.data.TStart; //Terminal Start Date
                    this.orders[index].TEnd = response.data.TEnd; //Terminal End Date
                    this.orders[index].StStart = response.data.StStart; //Station Start Date
                    this.orders[index].StEnd = response.data.StEnd; //Station End Date
                    await this.updateLoadByOrders(index);
                    await this.generateParamsETAByOrder(index);
                    console.log('Array Order', this.orders[index]);

                    //  this.orders[]
                    //    await  this.showShiftDetails();
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Comment Save'
                    });
                })
                .catch(error => {
                    order.saving = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    console.log(error);
                });
        },
        //show all orders in panels
        view: function() {
            this.viewOrders = !this.viewOrders;
            if (this.viewOrders) {
                this.all();
            } else {
                this.none();
            }
        },
        all: function() {
            this.panel = [...Array(this.orders.length).keys()].map((k, i) => i);
        },
        // Reset the panel
        none: function() {
            this.panel = [];
        },
        //format date yyyy-MM-ddThh:mm
        dateFormatDateTimeLocal: function(d) {
            if (d) {
                var date = moment(d);
                return date.format(moment.HTML5_FMT.DATETIME_LOCAL);
            } else {
                return '';
            }
        },
        //  format date YYYY-MM-DD HH:mm:ss
        dateFormatNormal: function(d) {
            if (d) {
                var date = moment(d);
                return date.format('YYYY-MM-DD HH:mm:ss');
            }
        },
        changeDateOrders: function(order, prop, value) {
            this.$store.state.isLoading = true;
            this.orders.forEach((e, i) => {
                if (e.OrderID == order.OrderID) {
                    this.orders[i][prop] = value;
                    this.orders[i].timeDiffT = this.getTimeDiff(
                        this.orders[i].TStart,
                        this.orders[i].TEnd
                    );
                    this.orders[i].timeDiffSt = this.getTimeDiff(
                        this.orders[i].StStart,
                        this.orders[i].StEnd
                    );
                }
            });
            this.$store.state.isLoading = false;
        },
        loadProductsOrder: function(orderID) {
            this.productsOrder.length = 0;
            axios
                .get('order-detail/order/' + orderID)
                .then(response => {
                    this.productsOrder.push(response.data.data);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getTimeDiff: function(start_date, end_date) {
            console.log(start_date, end_date);
            var duration;
            var hours;

            if (start_date !== undefined && end_date !== undefined) {
                var start = moment(start_date);
                var end = moment(end_date);
                duration = moment.duration(end.diff(start));
                hours = duration.asHours().toFixed(2);
            } else {
                hours = 'N/A';
            }

            return hours;
        },
        saveModal: function(itm) {
            for (let i = 0; i < itm.length; i++) {
                var params = {
                    DispatchedQuantity: itm[0].DispatchedQuantity
                };
                console.log(params);
            }
        },
        saveOrderData: function() {
            console.log('Aqui!!');
            var str = this.$store;
            for (let j = 0; j < this.productsOrder.length; j++) {
                var orderDetailID = this.productsOrder[j][0].id;
                console.log(this.productsOrder[j][0].id);
                var params = {
                    DispatchedQuantity: this.productsOrder[j][0]
                        .DispatchedQuantity
                };

                axios
                    .put('order-detail/' + orderDetailID, params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response);
                        this.$store.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Ord QTY saved successfully'
                        });
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
        },
        /*dragMoveOrder: async function() {
            await this.updateFor();
            this.updateLoadOrder();
        },
        updateFor: function() {
            var startTime = moment(this.shiftDetails.ShiftStartTime);
            var grpLoadNum = 1;
            var numOrd = 0;
            var loadNum = 0;
            var hrs = 0;
            var eta = null;
            var order_values = {};
            var gp = 0;
            var d1,
                d2,
                rt,
                ro = 0;
            for (const num in this.orders) {
                if (num % 2 == 0) {
                    this.orders[num].tbFont = 'tbDarkFont';
                    this.orders[num].rowsCtm = 'rowsDarkCtm mb-1';
                } else {
                    this.orders[num].tbFont = 'tbFont';
                    this.orders[num].rowsCtm = 'rowsCtm mb-1';
                }
                if (this.orders[num].LoadNumOrd == null) {
                    hrs = 3;
                    //this.shiftOrders[driverIndex][num].StandardHours[0]
                    //    .stHrs * 2;
                    eta = startTime
                        .add(hrs, 'hours')
                        .format('YYYY-MM-DD HH:mm:ss');
                    if (this.orders[num].RTTime > eta) {
                        rt = moment(this.orders[num].RTTime);
                        d1 = moment.duration(rt.diff(eta));
                        gp = d1.asHours().toFixed(2) * 1;
                    } else if (this.orders[num].ROTime < eta) {
                        ro = moment(this.orders[num].ROTime);
                        d2 = moment.duration(ro.diff(eta));
                        gp = d2.asHours().toFixed(2) * 1;
                    }
                    numOrd = 0;
                    loadNum = +loadNum + 1;
                    order_values = {
                        LoadNum: loadNum,
                        LoadNumOrd: null,
                        ETATime: eta,
                        GoalPost: gp
                    };
                    var str = this.$store;
                    axios
                        .put(
                            'order/' + this.orders[num].OrderID,
                            order_values,
                            {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            }
                        )
                        // eslint-disable-next-line no-unused-vars
                        .then(response => {
                            console.log('Success! updateLoadOrder');
                            this.$store.state.isLoading = false;
                        })
                        .catch(function(error) {
                            str.state.isLoading = false;
                            console.log(error);
                            if (error.response.status === 403) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'You do not have the permission to use this function.'
                                });
                            }
                            if (error.response.status === 500) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'An error has ocurred, please try again.'
                                });
                            }
                        });
                    this.orders[num].LoadNum = loadNum;
                    this.orders[num].GoalPost = gp;
                } else {
                    console.log(this.orders[num].LoadNumOrd);
                    grpLoadNum = this.orders[num].LoadNum;
                    var grpLoadNumOrd = this.orders[num].LoadNumOrd;
                    numOrd = +numOrd + 1;
                    // console.log('loadNum', loadNum);
                    // console.log('groupNum', grpLoadNum);
                    if (grpLoadNum != loadNum) {
                        loadNum = +loadNum + 1;
                        numOrd = 1;
                    } else if (grpLoadNumOrd > 0 && numOrd == 1) {
                        loadNum = +loadNum + 1;
                        numOrd = 1;
                    }

                    if (numOrd > 1) {
                        hrs = 0.5;
                        eta = startTime
                            .add(hrs, 'hours')
                            .format('YYYY-MM-DD HH:mm:ss');
                    } else {
                        hrs = 3;
                        // this.orders[num].StandardHours[0]
                        //     .stHrs * 2;
                        eta = startTime
                            .add(hrs, 'hours')
                            .format('YYYY-MM-DD HH:mm:ss');
                    }
                    if (this.orders[num].RTTime > eta) {
                        rt = moment(this.orders[num].RTTime);
                        d1 = moment.duration(rt.diff(eta));
                        gp = d1.asHours().toFixed(2) * 1;
                    } else if (this.orders[num].ROTime < eta) {
                        ro = moment(this.orders[num].ROTime);
                        d2 = moment.duration(ro.diff(eta));
                        gp = d2.asHours().toFixed(2) * 1;
                    }

                    order_values = {
                        LoadNum: loadNum,
                        LoadNumOrd: numOrd,
                        ETATime: eta,
                        GoalPost: gp
                    };
                    axios
                        .put(
                            'order/' + this.orders[num].OrderID,
                            order_values,
                            {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            }
                        )
                        // eslint-disable-next-line no-unused-vars
                        .then(response => {
                            console.log('Success!');
                            this.$store.state.isLoading = false;
                        })
                        .catch(function(error) {
                            console.log(error);

                            this.$store.state.isLoading = false;
                            if (error.response.status === 403) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'You do not have the permission to use this function.'
                                });
                            }
                            if (error.response.status === 500) {
                                str.dispatch('setSnackbar', {
                                    color: 'error',
                                    text:
                                        'An error has ocurred, please try again.'
                                });
                            }
                        });
                    this.orders[num].LoadNum = loadNum;
                    this.orders[num].LoadNumOrd = numOrd;
                    this.orders[num].GoalPost = gp;
                }

                this.$store.state.isLoading = false;
            }
        },*/
        updateLoadOrder: async function() {
            //Verifica que GPSShiftStart no este nulo
            var hrs = 3;
            var Gps = null;
            if (this.getMsk('GPSShiftStart') != '') {
                Gps = moment(this.getMsk('GPSShiftStart'));
            } else {
                Gps = moment(this.shiftDetails.ShiftStartTime);
            }
            var tmpETA = null;
            var tmpStationGPSEnd = null;
            await this.orders.forEach(async ord => {
                if (tmpETA === null) {
                    //En la primera iteracion toma la fecha de inicion la del GPSStartTime
                    ord.ETATime = Gps.add(hrs, 'hours').format(
                        'YYYY-MM-DD HH:mm:ss'
                    );
                    tmpETA = moment(ord.ETATime);
                    if (ord.StEnd == null || ord.StEnd == '') {
                        tmpStationGPSEnd = null;
                    } else {
                        tmpStationGPSEnd = moment(ord.StEnd);
                    }
                } else {
                    if (
                        tmpStationGPSEnd == null ||
                        isNaN(tmpStationGPSEnd._i)
                    ) {
                        // En esta iteracion si el load anterior no esta finalizado toma la fecha a calcular en base con ord.ETATime
                        if (ord.LoadNumOrd > 1) {
                            ord.ETATime = tmpETA
                                .add(0.5, 'hours')
                                .format('YYYY-MM-DD HH:mm:ss');
                        } else {
                            ord.ETATime = tmpETA
                                .add(hrs, 'hours')
                                .format('YYYY-MM-DD HH:mm:ss');
                        }
                        tmpETA = moment(ord.ETATime);
                        tmpStationGPSEnd = moment(ord.StEnd);
                        console.log(tmpStationGPSEnd);
                    } else {
                        console.log('else', tmpStationGPSEnd, tmpETA);
                        //En esta Iteracion Si el load anterior esta finalizado toma la fecha a calcular en base con ord.StEnd
                        if (ord.LoadNumOrd > 1) {
                            ord.ETATime = tmpStationGPSEnd
                                .add(0.5, 'hours')
                                .format('YYYY-MM-DD HH:mm:ss');
                        } else {
                            ord.ETATime = tmpStationGPSEnd
                                .add(hrs, 'hours')
                                .format('YYYY-MM-DD HH:mm:ss');
                        }

                        tmpETA = moment(ord.ETATime);
                        tmpStationGPSEnd = moment(ord.StEnd);
                    }
                }
            });
            this.generateParamsETA();
        },
        updateLoadByOrders: async function(index) {
            //Verifica que la orden desde la que se esta iniciando no sea la ultima y no quiebre el bucle for
            if (index + 1 < this.orders.length) {
                const hrs = 3;
                var tmpETA = null;
                console.log(this.orders[index].StEnd);
                if (this.orders[index].StEnd != null) {
                    tmpETA = moment(this.orders[index].StEnd);
                } else {
                    tmpETA = moment(this.orders[index].ETATime);
                }
                console.log(tmpETA);
                for (let i = index + 1; i < this.orders.length; i++) {
                    console.log(tmpETA);
                    if (this.orders[i].LoadNumOrd > 1) {
                        this.orders[i].ETATime = tmpETA
                            .add(0.5, 'hours')
                            .format('YYYY-MM-DD HH:mm:ss');
                    } else {
                        this.orders[i].ETATime = tmpETA
                            .add(hrs, 'hours')
                            .format('YYYY-MM-DD HH:mm:ss');
                    }

                    if (
                        this.orders[i].StEnd == null ||
                        this.orders[i].StEnd == ''
                    ) {
                        tmpETA = moment(this.orders[i].ETAtime);
                        console.log('ETA');
                    } else {
                        tmpETA = moment(this.orders[i].StEnd);
                        console.log('ST');
                    }
                }
            }
        },
        getMsk: function(id) {
            return document.getElementById(id).value;
        },
        callAsync: async function(x) {
            await this.getShiftDetails();

            this.comboDrivers = this.shiftDetailsDrivers[x];

            console.log('This.ComboDrivers', this.comboDrivers);
            this.showShiftDetails();
        },
        generateParamsETA: async function() {
            var str = this.$store;
            var data = [];
            await this.orders.forEach(async ord => {
                data.push({ OrderID: ord.OrderID, ETATime: ord.ETATime });
            });
            console.log(data);
            var params = {
                data: data
            };
            axios
                .post('order/multiple/update/eta', params)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'primary',
                        text: 'ETA Updated'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        updateOrder: function(ord) {
            var str = this.$store;
            var params = {
                dropped: 1
            };
            axios
                .put('order/' + ord, params)
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'primary',
                        text: 'Order dropped'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        generateParamsETAByOrder: function(index) {
            var str = this.$store;
            var data = [];
            if (index + 1 < this.orders.length) {
                for (let i = index + 1; i < this.orders.length; i++) {
                    data.push({
                        OrderID: this.orders[i].OrderID,
                        ETATime: this.orders[i].ETATime
                    });
                }

                console.log(data);
                var params = {
                    data: data
                };
                axios
                    .post('order/multiple/update/eta', params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        console.log(response.data);
                        str.dispatch('setSnackbar', {
                            color: 'primary',
                            text: 'ETA Updated'
                        });
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
        }
    }
};
</script>

<style>
* {
    padding: 0px;
    margin: 0px;
}

.contain {
    padding: 10px;
}

#combox .v-list-item__title {
    font-size: 10px !important;
}

.lin1 {
    display: inline-block;
    width: 49%;
    margin-left: 1%;
}

.lin15 {
    display: inline-block;
    width: 24%;
    margin-left: 1%;
}

.linTab1 {
    width: 100%;
}

.tbla table {
    float: left;
    margin-top: 2px;
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
}

.tbla th {
    text-align: center;
    padding: 2px;
    font-size: 10px;
    color: #888;
}

.tbla td {
    background: #ddd;
    text-align: center;
    padding: 2px;
    font-size: 12px;
}

.lin2 {
    margin-left: 4px;
    width: 100%;
}

.inl1 {
    float: left;
    display: inline-block;
    width: 40%;
}

.inlTbl {
    float: left;
    display: inline-block;
    width: 45%;
}

.inl2 {
    float: left;
    display: inline-block;
    width: 44%;
    margin-left: 1%;
}

.inl3 {
    display: inline-block;
    float: right;
    width: 14%;
    margin-left: 1%;
}

.cardM {
    padding: 0px;
    margin: 0px;
}

.v-list-item__content {
    font-size: 16px;
}

.linCtm {
    width: 100%;
    display: inline-block;
}

.linCtmB {
    width: 10%;
    display: inline-block;
}

.dspSum {
}

.sumTabs {
    width: 70%;
    display: inline-block;
}

.sumComt {
    width: 29%;
    margin-left: 1%;
    display: inline-block;
}

.comt {
    width: 29%;
    margin-left: 1%;
    display: inline-block;
    float: right;
}

.tabs {
    width: 70%;
    display: inline-block;
    float: left;
}

.rowsCtm {
    width: 100%;
    background: #fff;
    float: left;
}

.rowsDarkCtm {
    background: #bfd6de;
    width: 100%;
    float: left;
}

.rowsDarkCtm table {
    width: 100%;
}

.rowsCtm table {
    width: 100%;
}

.tbFont {
    font-size: 8px;
}

.tbFont td {
    background: #fff;
}

.tbDarkFont {
    border-spacing: 0px;
    font-size: 8px;
}

.tbDarkFont td {
    border-spacing: 0px;
    background: #bfd6de;
}

#divs .v-text-field__details {
    display: none;
}

.timeLoadValue {
    background-color: #ceabab;
    padding: 3px;
    border-radius: 7px;
}

.timeGeneralValue {
    background-color: #c3b0ff;
    padding: 3px;
    border-radius: 7px;
}

.timeShiftValue {
    background-color: #f1b053;
    padding: 3px;
    border-radius: 7px;
}

.replicatePlaceholder {
    margin: 0 !important;
    padding: 2px 0 0;
    border-bottom: 1px solid #777777;
    color: #777777;
    width: 140px;
}

.replicateShiftPlaceholder {
    margin: 0 !important;
    padding: 2px 0 0;
    color: #777777;
    width: 140px;
}
</style>
